// // // import React, { useState, useEffect } from "react";
// // // import { useLocation, useNavigate } from "react-router-dom";
// // // import { ref, get, update } from "firebase/database";
// // // import { getAuth, onAuthStateChanged } from "firebase/auth";
// // // import { database as db } from "../FirebaseConfig";
// // // import toast from "react-hot-toast";

// // // export default function LearnBK() {
// // //   const navigate = useNavigate();
// // //   const location = useLocation();

// // //   const auth = getAuth();
// // //   const [userData, setUserData] = useState({ name: "", mobile: "", date: "", slot: "" });
// // //   const [userEmail, setUserEmail] = useState(null);
// // //   const [dates, setDates] = useState([]);
// // //   const [user, setUser] = useState(null);

// // //   const [slots, setSlots] = useState({});
// // //   const [loading, setLoading] = useState(true);
// // //   const [bookedSlot, setBookedSlot] = useState(null);

// // //   useEffect(() => {
// // //     const redirectPath =
// // //       new URLSearchParams(location.search).get("redirect") || "/learn-beekeeping";

// // //     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
// // //       if (currentUser) {
// // //         setUser(currentUser);
// // //         setUserEmail(currentUser.email);
// // //         checkUserAlreadyBooked(currentUser.email);
// // //       } else {
// // //         setUser(null);
// // //         navigate(`/login?redirect=${redirectPath}`);
// // //       }
// // //       fetchDates();

// // //     });

// // //     return () => unsubscribe();
// // //   }, [navigate]);

  
// // //   const fetchDates = async () => {
// // //     const dateRef = ref(db, "slots");
// // //     try {
// // //       const snapshot = await get(dateRef);
// // //       if (snapshot.exists()) {
// // //         const allDates = snapshot.val();
// // //         console.log("Raw Dates from Firebase:", allDates); // Debugging
  
// // //         const currentDate = new Date();
// // //         currentDate.setHours(0, 0, 0, 0); // Normalize to midnight
  
// // //         // Convert and filter future dates
// // //         const futureDates = Object.keys(allDates).filter(dateString => {
// // //           const [year, month, day] = dateString.split("-").map(Number);
// // //           const dateObj = new Date(year, month - 1, day); // Convert string to Date object
// // //           dateObj.setHours(0, 0, 0, 0); // Normalize to midnight
  
// // //           console.log(`Checking Date: ${dateString} => ${dateObj} (Today: ${currentDate})`); // Debugging
// // //           return dateObj >= currentDate;
// // //         });
  
// // //         console.log("Filtered Future Dates:", futureDates); // Debugging
  
// // //         setDates(futureDates);
// // //       } else {
// // //         console.log("No dates found in Firebase");
// // //         setDates([]);
// // //       }
// // //     } catch (error) {
// // //       console.error("Error fetching dates:", error);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };
  


// // //   const checkUserAlreadyBooked = async (email) => {
// // //     const dateRef = ref(db, "slots");
// // //     try {
// // //       const snapshot = await get(dateRef);
// // //       if (snapshot.exists()) {
// // //         const allSlots = snapshot.val();
// // //         for (let date in allSlots) {
// // //           for (let slotId in allSlots[date]) {
// // //             if (allSlots[date][slotId].users?.includes(email)) {
// // //               setBookedSlot({ date, slotName: allSlots[date][slotId].name });
// // //               return true;
// // //             }
// // //           }
// // //         }
// // //       }
// // //     } catch (error) {
// // //       console.error("Error checking existing booking:", error);
// // //     }
// // //     return false;
// // //   };

// // //   const fetchSlotsForDate = async (selectedDate) => {
// // //     if (!selectedDate) return;
// // //     setUserData({ ...userData, slot: "", date: selectedDate });
  
// // //     const slotRef = ref(db, `slots/${selectedDate}`);
// // //     try {
// // //       const snapshot = await get(slotRef);
// // //       if (snapshot.exists()) {
// // //         const allSlots = snapshot.val();
// // //         const currentTime = new Date();
  
// // //         let filteredSlots = allSlots;
  
// // //         // If selected date is today, remove past time slots
// // //         if (selectedDate === new Date().toISOString().split("T")[0]) {
// // //           filteredSlots = Object.fromEntries(
// // //             Object.entries(allSlots).filter(([key, slot]) => {
// // //               const [hour, minute] = slot.name.split(" ")[0].split(":").map(Number);
// // //               const isPM = slot.name.includes("PM") && hour !== 12;
// // //               const slotTime = new Date(selectedDate);
// // //               slotTime.setHours(isPM ? hour + 12 : hour, minute, 0); // Convert 12-hour format to 24-hour format
  
// // //               console.log(`Checking Slot: ${slot.name} -> Time: ${slotTime} (Current: ${currentTime})`); // Debugging
  
// // //               return slotTime >= currentTime; // Keep only future slots
// // //             })
// // //           );
// // //         }
  
// // //         setSlots(filteredSlots);
// // //       } else {
// // //         setSlots({});
// // //       }
// // //     } catch (error) {
// // //       console.error("Error fetching slots:", error);
// // //     }
// // //   };
  

// // //   const handleChange = (e) => {
// // //     setUserData({ ...userData, [e.target.name]: e.target.value });

// // //     if (e.target.name === "date") {
// // //       fetchSlotsForDate(e.target.value);
// // //     }
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();
// // //     const { name, mobile, date, slot } = userData;

// // //     if (!name || !mobile || !date || !slot) {
// // //       toast.error("Please fill in all details.");
// // //       return;
// // //     }

// // //     if (bookedSlot) {
// // //       toast.success(`You have already booked: ${bookedSlot.slotName} on ${bookedSlot.date}`);
// // //       return;
// // //     }

// // //     const selectedSlot = slots[slot];
// // //     if (selectedSlot.booked >= selectedSlot.limit) {
// // //       toast.error("This slot is fully booked. Please select another slot.");
// // //       return;
// // //     }

// // //     const slotRef = ref(db, `slots/${date}/${slot}`);

// // //     try {
// // //       await update(slotRef, {
// // //         booked: selectedSlot.booked + 1,
// // //         users: [...(selectedSlot.users || []), userEmail],
// // //       });

// // //       toast.success("Slot booked successfully!");
// // //       fetchSlotsForDate(date);
// // //       checkUserAlreadyBooked(user.email);

// // //     } catch (error) {
// // //       console.error("Error booking slot:", error);
// // //       alert("Failed to book the slot.");
// // //     }
// // //   };

// // //   return (
// // //     <div className="max-w-lg mx-auto p-6 mt-32 bg-white shadow-lg rounded-md mt-20 mb-10 border border-orange-300">
// // //       <h2 className="text-3xl font-bold text-[#f47d02] mb-4 text-center">Book a Slot</h2>

// // //       {bookedSlot && (
// // //         <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-900 p-4 mb-4">
// // //           <p className="font-bold">You have already booked:</p>
// // //           <p>{bookedSlot.slotName} on {bookedSlot.date}</p>
// // //         </div>
// // //       )}

// // //       {loading ? (
// // //         <p className="text-center text-gray-500">Loading dates...</p>
// // //       )  : (
// // //         <>
// // //         {!bookedSlot ? (
// // //         <form  onSubmit={handleSubmit} className="space-y-4 " >
// // //           <div>
// // //             <label className="block font-medium text-gray-700">Name:</label>
// // //             <input
// // //               type="text"
// // //               name="name"
// // //               value={userData.name}
// // //               onChange={handleChange}
// // //               className="w-full p-2 border rounded focus:ring-[#f47d02] focus:border-[#f47d02]"
// // //               required
// // //             />
// // //           </div>

// // //           <div>
// // //             <label className="block font-medium text-gray-700">Mobile Number:</label>
// // //             <input
// // //               type="tel"
// // //               name="mobile"
// // //               value={userData.mobile}
// // //               onChange={handleChange}
// // //               className="w-full p-2 border rounded focus:ring-[#f47d02] focus:border-[#f47d02]"
// // //               required
// // //             />
// // //           </div>

// // //           <div>
// // //             <label className="block font-medium text-gray-700">Email:</label>
// // //             <input
// // //               type="email"
// // //               value={userEmail || ""}
// // //               disabled
// // //               className="w-full p-2 border rounded bg-gray-100"
// // //             />
// // //           </div>

// // //           <div>
// // //             <label className="block font-medium text-gray-700">Select Date:</label>
// // //             <select
// // //               name="date"
// // //               value={userData.date}
// // //               onChange={handleChange}
// // //               className="w-full p-2 border rounded focus:ring-[#f47d02] focus:border-[#f47d02]"
// // //               required
// // //             >
// // //               <option value="">Choose a date</option>
// // //               {dates.map((date) => (
// // //                 <option key={date} value={date}>{date}</option>
// // //               ))}
// // //             </select>
// // //           </div>

// // //           {userData.date && (
// // //             <div>
// // //               <label className="block font-medium text-gray-700">Select Slot:</label>
// // //               <select
// // //                 name="slot"
// // //                 value={userData.slot}
// // //                 onChange={handleChange}
// // //                 className="w-full p-2 border rounded focus:ring-[#f47d02] focus:border-[#f47d02]"
// // //                 required
// // //               >
// // //                 <option value="">Choose a slot</option>
// // //                 {Object.entries(slots).map(([key, slot]) => (
// // //                   <option key={key} value={key} disabled={slot.booked >= slot.limit}>
// // //                     {slot.name} ({slot.booked}/{slot.limit})
// // //                   </option>
// // //                 ))}
// // //               </select>
// // //             </div>
// // //           )}

// // //           <button
// // //             type="submit"
// // //             className="w-full bg-[#f47d02] text-white p-3 rounded-lg shadow-lg hover:bg-orange-600 transition duration-200"
// // //           >
// // //             Book Slot
// // //           </button>
// // //         </form>):(<></>)
// // // }
// // //         </>

// // //       )}
// // //     </div>
// // //   );
// // // }


// // import React, { useState, useEffect } from "react";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import { ref, get, update } from "firebase/database";
// // import { getAuth, onAuthStateChanged } from "firebase/auth";
// // import { database as db } from "../FirebaseConfig";
// // import toast from "react-hot-toast";
// // import { Calendar, Clock, User, Phone, Mail, CheckCircle } from "lucide-react"; // Added icons for better UX

// // export default function LearnBK() {
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const auth = getAuth();


// //   const MOBILE_REGEX = /^[6-9]\d{9}$/;

// //   const [userData, setUserData] = useState({ name: "", mobile: "", date: "", slot: "" });
// //   const [userEmail, setUserEmail] = useState(null);
// //   const [dates, setDates] = useState([]);
// //   const [user, setUser] = useState(null);
// //   const [slots, setSlots] = useState({});
// //   const [loading, setLoading] = useState(true);
// //   const [bookedSlot, setBookedSlot] = useState(null);

// //   useEffect(() => {
// //     const redirectPath = new URLSearchParams(location.search).get("redirect") || "/learn-beekeeping";
// //     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
// //       if (currentUser) {
// //         setUser(currentUser);
// //         setUserEmail(currentUser.email);
// //         checkUserAlreadyBooked(currentUser.email);
// //       } else {
// //         setUser(null);
// //         navigate(`/login?redirect=${redirectPath}`);
// //       }
// //       fetchDates();
// //     });
// //     return () => unsubscribe();
// //   }, [navigate]);

// //   // const fetchDates = async () => {
// //   //   const dateRef = ref(db, "slots");
// //   //   try {
// //   //     const snapshot = await get(dateRef);
// //   //     if (snapshot.exists()) {
// //   //       const allDates = snapshot.val();
// //   //       const currentDate = new Date();
// //   //       currentDate.setHours(0, 0, 0, 0);

// //   //       const futureDates = Object.keys(allDates).filter(dateString => {
// //   //         const [year, month, day] = dateString.split("-").map(Number);
// //   //         const dateObj = new Date(year, month - 1, day);
// //   //         dateObj.setHours(0, 0, 0, 0);
// //   //         return dateObj >= currentDate;
// //   //       });
// //   //       setDates(futureDates);
// //   //     }
// //   //   } catch (error) {
// //   //     console.error("Error fetching dates:", error);
// //   //   } finally {
// //   //     setLoading(false);
// //   //   }
// //   // };


// //   const formatDisplayDate = (dateString) => {
// //   const [year, month, day] = dateString.split("-");
// //   return `${day}-${month}-${year}`;
// // };

// // const handleChange = (e) => {
// //   const { name, value } = e.target;

// //   if (name === "mobile") {
// //     // Only allow numbers and limit to 10 digits
// //     const cleanedValue = value.replace(/\D/g, "").slice(0, 10);
// //     setUserData({ ...userData, [name]: cleanedValue });
// //   } else {
// //     setUserData({ ...userData, [name]: value });
// //   }

// //   if (name === "date") {
// //     fetchSlotsForDate(value);
// //   }
// // };

// //   const fetchDates = async () => {
// //   const dateRef = ref(db, "slots");
// //   try {
// //     const snapshot = await get(dateRef);
// //     if (snapshot.exists()) {
// //       const allDates = snapshot.val();
      
// //       const currentDate = new Date();
// //       currentDate.setHours(0, 0, 0, 0);

// //       // 1. Get and filter the dates
// //       const futureDates = Object.keys(allDates).filter(dateString => {
// //         const [year, month, day] = dateString.split("-").map(Number);
// //         const dateObj = new Date(year, month - 1, day);
// //         dateObj.setHours(0, 0, 0, 0);
// //         return dateObj >= currentDate;
// //       });

// //       // 2. SORT THE DATES (Chronological Order)
// //       // This ensures 2026-01-19 comes BEFORE 2026-02-01
// //       const sortedDates = futureDates.sort((a, b) => new Date(a) - new Date(b));

// //       setDates(sortedDates);
// //     } else {
// //       setDates([]);
// //     }
// //   } catch (error) {
// //     console.error("Error fetching dates:", error);
// //   } finally {
// //     setLoading(false);
// //   }
// // };
// //   const checkUserAlreadyBooked = async (email) => {
// //     const dateRef = ref(db, "slots");
// //     try {
// //       const snapshot = await get(dateRef);
// //       if (snapshot.exists()) {
// //         const allSlots = snapshot.val();
// //         for (let date in allSlots) {
// //           for (let slotId in allSlots[date]) {
// //             if (allSlots[date][slotId].users?.includes(email)) {
// //               setBookedSlot({ date, slotName: allSlots[date][slotId].name });
// //               return true;
// //             }
// //           }
// //         }
// //       }
// //     } catch (error) {
// //       console.error("Error checking existing booking:", error);
// //     }
// //     return false;
// //   };

// //   const fetchSlotsForDate = async (selectedDate) => {
// //     if (!selectedDate) return;
// //     setUserData({ ...userData, slot: "", date: selectedDate });
// //     const slotRef = ref(db, `slots/${selectedDate}`);
// //     try {
// //       const snapshot = await get(slotRef);
// //       if (snapshot.exists()) {
// //         const allSlots = snapshot.val();
// //         const currentTime = new Date();
// //         let filteredSlots = allSlots;

// //         if (selectedDate === new Date().toISOString().split("T")[0]) {
// //           filteredSlots = Object.fromEntries(
// //             Object.entries(allSlots).filter(([key, slot]) => {
// //               const [hour, minute] = slot.name.split(" ")[0].split(":").map(Number);
// //               const isPM = slot.name.includes("PM") && hour !== 12;
// //               const slotTime = new Date(selectedDate);
// //               slotTime.setHours(isPM ? hour + 12 : hour, minute, 0);
// //               return slotTime >= currentTime;
// //             })
// //           );
// //         }
// //         setSlots(filteredSlots);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching slots:", error);
// //     }
// //   };

// //   const handleDateChange = (date) => {
// //     setUserData({ ...userData, date, slot: "" });
// //     fetchSlotsForDate(date);
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //  const { name, mobile, date, slot } = userData;
// //     if (!name || !mobile || !date || !slot) {
// //     toast.error("Please fill in all details.");
// //     return;
// //   }

// //   // 2. Mobile Number Validation
// //   if (!MOBILE_REGEX.test(mobile)) {
// //     toast.error("Please enter a valid 10-digit mobile number.");
// //     return;
// //   }

// //     const selectedSlot = slots[userData.slot];
// //     const slotRef = ref(db, `slots/${userData.date}/${userData.slot}`);
// //     try {
// //       await update(slotRef, {
// //         booked: selectedSlot.booked + 1,
// //         users: [...(selectedSlot.users || []), userEmail],
// //       });
// //       toast.success("Booking Confirmed!");
// //       setBookedSlot({ date: userData.date, slotName: selectedSlot.name });
// //     } catch (error) {
// //       toast.error("Booking failed. Try again.");
// //     }
// //   };

// //   return (
// //     <div className="min-h-screen bg-gray-50 mt-20 py-12 px-4 sm:px-6 lg:px-8">
// //       <div className="max-w-4xl mx-auto">
// //         <div className="bg-white shadow-xl rounded-2xl overflow-hidden border border-orange-100">
          
// //           {/* Header Section */}
// //           <div className="bg-gradient-to-r from-orange-500 to-yellow-500 p-8 text-white text-center">
// //             <h2 className="text-3xl font-extrabold tracking-tight">Learn Beekeeping</h2>
// //             <p className="mt-2 text-orange-50">Book your hands-on session with the bees</p>
// //           </div>

// //           <div className="p-6 md:p-10">
// //             {bookedSlot ? (
// //               <div className="flex flex-col items-center justify-center py-10 text-center">
// //                 <div className="bg-green-100 p-4 rounded-full mb-4">
// //                   <CheckCircle className="w-16 h-16 text-green-600" />
// //                 </div>
// //                 <h3 className="text-2xl font-bold text-gray-800">You're all set!</h3>
// //                 <p className="text-gray-600 mt-2">
// //                   Your session is confirmed for <span className="font-semibold text-orange-600">{bookedSlot.slotName}</span> on <span className="font-semibold text-orange-600">{bookedSlot.date}</span>.
// //                 </p>
// //                 <button onClick={() => navigate('/dashboard')} className="mt-8 px-6 py-2 bg-orange-500 text-white rounded-full hover:bg-orange-600 transition">
// //                   Go to Dashboard
// //                 </button>
// //               </div>
// //             ) : loading ? (
// //               <div className="flex justify-center items-center py-20">
// //                 <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
// //               </div>
// //             ) : (
// //               <form onSubmit={handleSubmit} className="space-y-8">
                
// //                 {/* Personal Info Grid */}
// //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
// //                   <div className="relative">
// //                     <label className="text-sm font-semibold text-gray-600 mb-1 block">Full Name</label>
// //                     <div className="flex items-center border rounded-lg px-3 py-2 bg-white focus-within:ring-2 ring-orange-400">
// //                       <User className="w-5 h-5 text-gray-400 mr-2" />
// //                       <input
// //                         type="text"
// //                         name="name"
// //                         value={userData.name}
// //                         onChange={(e) => setUserData({ ...userData, name: e.target.value })}
// //                         className="w-full outline-none text-gray-700"
// //                         placeholder="Full Name"
// //                         required
// //                       />
// //                     </div>
// //                   </div>

// //                   <div className="relative">
// //                     <label className="text-sm font-semibold text-gray-600 mb-1 block">Mobile Number</label>
// //                     <div className="flex items-center border rounded-lg px-3 py-2 bg-white focus-within:ring-2 ring-orange-400">
// //                       <Phone className="w-5 h-5 text-gray-400 mr-2" />
// //                       <input
// //                         type="tel"
// //                         name="mobile"
// //                         value={userData.mobile}
// //                         onChange={(e) => setUserData({ ...userData, mobile: e.target.value })}
// //                         className="w-full outline-none text-gray-700"
// //                         placeholder="9876543210"
// //                         required
// //                       />
// //                     </div>
// //                   </div>

// //                   <div className="md:col-span-2 relative">
// //                     <label className="text-sm font-semibold text-gray-600 mb-1 block">Registered Email</label>
// //                     <div className="flex items-center border rounded-lg px-3 py-2 bg-gray-50">
// //                       <Mail className="w-5 h-5 text-gray-400 mr-2" />
// //                       <input type="email" value={userEmail || ""} disabled className="w-full bg-transparent text-gray-500 cursor-not-allowed outline-none" />
// //                     </div>
// //                   </div>
// //                 </div>

// //                 {/* Date Selection Grid */}
// //                 <div>
// //                   <label className="text-sm font-semibold text-gray-600 mb-3 block flex items-center">
// //                     <Calendar className="w-4 h-4 mr-2" /> Select Training Date
// //                   </label>
// //                   <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
// //                     {dates.map((date) => (
// //                       <button
// //                         key={date}
// //                         type="button"
// //                         onClick={() => handleDateChange(date)}
// //                         className={`p-3 text-sm font-medium rounded-xl border transition-all ${
// //                           userData.date === date 
// //                           ? "bg-orange-500 text-white border-orange-500 shadow-md" 
// //                           : "bg-white text-gray-700 border-gray-200 hover:border-orange-300"
// //                         }`}
// //                       >
// // {formatDisplayDate(date)}
// //                       </button>
// //                     ))}
// //                   </div>
// //                 </div>

// //                 {/* Slot Selection Grid */}
// //                 {userData.date && (
// //                   <div className="animate-fade-in">
// //                     <label className="text-sm font-semibold text-gray-600 mb-3 block flex items-center">
// //                       <Clock className="w-4 h-4 mr-2" /> Available Time Slots
// //                     </label>
// //                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
// //                       {Object.entries(slots).map(([key, slot]) => {
// //                         const isFull = slot.booked >= slot.limit;
// //                         const isSelected = userData.slot === key;
// //                         return (
// //                           <button
// //                             key={key}
// //                             type="button"
// //                             disabled={isFull}
// //                             onClick={() => setUserData({ ...userData, slot: key })}
// //                             className={`flex justify-between items-center p-4 rounded-xl border transition-all ${
// //                               isFull ? "bg-gray-50 text-gray-400 cursor-not-allowed" : 
// //                               isSelected ? "bg-orange-50 border-orange-500 ring-1 ring-orange-500" : 
// //                               "bg-white hover:border-orange-300"
// //                             }`}
// //                           >
// //                             <span className={`font-medium ${isSelected ? "text-orange-700" : "text-gray-700"}`}>
// //                               {slot.name}
// //                             </span>
// //                             <span className={`text-xs px-2 py-1 rounded-md ${isFull ? "bg-gray-200" : "bg-orange-100 text-orange-700"}`}>
// //                               {isFull ? "Sold Out" : `${slot.limit - slot.booked} left`}
// //                             </span>
// //                           </button>
// //                         );
// //                       })}
// //                     </div>
// //                   </div>
// //                 )}

// //                 <button
// //                   type="submit"
// //                   className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-4 rounded-xl font-bold text-lg shadow-lg hover:from-orange-600 hover:to-orange-700 transform hover:-translate-y-0.5 transition-all focus:ring-4 ring-orange-200"
// //                 >
// //                   Confirm Booking
// //                 </button>
// //               </form>
// //             )}
// //           </div>
// //         </div>
// //         {/* <p className="text-center text-gray-400 text-sm mt-8">Secure Payment & Booking Powered by Saola Innovations</p> */}
// //       </div>
// //     </div>
// //   );
// // }


// // import React, { useState, useEffect, useMemo } from "react";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import { ref, get, update } from "firebase/database";
// // import { getAuth, onAuthStateChanged } from "firebase/auth";
// // import { database as db } from "../FirebaseConfig";
// // import toast from "react-hot-toast";
// // import {
// //   Calendar,
// //   Clock,
// //   User,
// //   Phone,
// //   Mail,
// //   CheckCircle,
// //   Hexagon,
// //   Shield,
// //   Star,
// //   Info,
// //   ChevronRight,
// //   Sparkles,
// //   BadgeCheck,
// // } from "lucide-react";

// // export default function LearnBK() {
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const auth = getAuth();
// //   const MOBILE_REGEX = /^[6-9]\d{9}$/;

// //   const [userData, setUserData] = useState({
// //     name: "",
// //     mobile: "",
// //     age: "",
// //     workshopType: "",
// //     participants: 1,
// //     experience: "Beginner",
// //     questions: "",
// //     date: "",
// //     slot: "",
// //   });

// //   const [userEmail, setUserEmail] = useState(null);
// //   const [dates, setDates] = useState([]);
// //   const [slots, setSlots] = useState({});
// //   const [loading, setLoading] = useState(true);
// //   const [bookedSlot, setBookedSlot] = useState(null);

// // const workshopOptions = [
// //   {
// //     id: "1-Day",
// //     typeLabel: "Beginner Friendly",
// //     title: "1-Day Experiential Workshop",
// //     price: "₹2,000",
// //     priceNote: "per person",
// //     badge: "Best for Beginners",
// //     tone: "beginner", // for styling
// //     points: [
// //       "Live hive visit",
// //       "Safety gear provided",
// //       "Tool & frame demo",
// //       "Hands-on honey extraction",
// //       "Honey tasting",
// //       "Free honey jar",
// //       "Certificate",
// //     ],
// //     cta: "Book Seat",
// //   },
// //   {
// //     id: "5-Day",
// //     typeLabel: "Professional Track",
// //     title: "5-Day Beekeeping Training",
// //     price: "₹11,000",
// //     priceNote: "per person",
// //     badge: "Most Popular",
// //     tone: "pro",
// //     points: [
// //       "Half-day theory + practical",
// //       "Hive inspections",
// //       "Extraction training",
// //       "Disease & hive care",
// //       "Business basics",
// //       "Training materials",
// //       "Free hive setup",
// //     ],
// //     cta: "Book Seat",
// //   },
// //   {
// //     id: "Lecture",
// //     typeLabel: "Theory Track",
// //     title: "Lecture Only",
// //     price: "₹7,500",
// //     priceNote: "per person",
// //     badge: null,
// //     tone: "neutral",
// //     points: ["Theory without hive kit", "Learn concepts clearly", "Certificate (optional)"],
// //     cta: "Select",
// //   },
// // ];

// //   useEffect(() => {
// //     const redirectPath =
// //       new URLSearchParams(location.search).get("redirect") || "/learn-beekeeping";

// //     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
// //       if (currentUser) {
// //         setUserEmail(currentUser.email);
// //         checkUserAlreadyBooked(currentUser.email);
// //       } else {
// //         navigate(`/login?redirect=${redirectPath}`);
// //       }
// //       fetchDates();
// //     });

// //     return () => unsubscribe();
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [navigate]);

// //   const fetchDates = async () => {
// //     const dateRef = ref(db, "slots");
// //     try {
// //       const snapshot = await get(dateRef);
// //       if (snapshot.exists()) {
// //         const allDates = snapshot.val();
// //         const currentDate = new Date();
// //         currentDate.setHours(0, 0, 0, 0);

// //         const futureDates = Object.keys(allDates).filter((dateString) => {
// //           const [year, month, day] = dateString.split("-").map(Number);
// //           const dateObj = new Date(year, month - 1, day);
// //           dateObj.setHours(0, 0, 0, 0);
// //           return dateObj >= currentDate;
// //         });

// //         setDates(futureDates.sort((a, b) => new Date(a) - new Date(b)));
// //       }
// //     } catch (error) {
// //       console.error("Error fetching dates:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const checkUserAlreadyBooked = async (email) => {
// //     const dateRef = ref(db, "slots");
// //     try {
// //       const snapshot = await get(dateRef);
// //       if (snapshot.exists()) {
// //         const allSlots = snapshot.val();
// //         for (let date in allSlots) {
// //           for (let slotId in allSlots[date]) {
// //             if (allSlots[date][slotId].users?.includes(email)) {
// //               setBookedSlot({ date, slotName: allSlots[date][slotId].name });
// //               return true;
// //             }
// //           }
// //         }
// //       }
// //     } catch (error) {
// //       console.error(error);
// //     }
// //     return false;
// //   };

// //   const fetchSlotsForDate = async (selectedDate) => {
// //     if (!selectedDate) return;
// //     setUserData((prev) => ({ ...prev, slot: "", date: selectedDate }));

// //     const slotRef = ref(db, `slots/${selectedDate}`);
// //     try {
// //       const snapshot = await get(slotRef);
// //       if (snapshot.exists()) {
// //         const allSlots = snapshot.val();
// //         const currentTime = new Date();
// //         let filteredSlots = allSlots;

// //         if (selectedDate === new Date().toISOString().split("T")[0]) {
// //           filteredSlots = Object.fromEntries(
// //             Object.entries(allSlots).filter(([_, slot]) => {
// //               const [hour, minute] = slot.name.split(" ")[0].split(":").map(Number);
// //               const isPM = slot.name.includes("PM") && hour !== 12;
// //               const slotTime = new Date(selectedDate);
// //               slotTime.setHours(isPM ? hour + 12 : hour, minute, 0);
// //               return slotTime >= currentTime;
// //             })
// //           );
// //         }

// //         setSlots(filteredSlots);
// //       } else {
// //         setSlots({});
// //       }
// //     } catch (error) {
// //       console.error(error);
// //       setSlots({});
// //     }
// //   };

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     if (name === "mobile") {
// //       setUserData({ ...userData, [name]: value.replace(/\D/g, "").slice(0, 10) });
// //     } else {
// //       setUserData({ ...userData, [name]: value });
// //     }
// //   };

// //   const handleWorkshopSelect = (id) => {
// //     setUserData((p) => ({
// //       ...p,
// //       workshopType: id,
// //       date: "",
// //       slot: "",
// //     }));
// //     setSlots({});
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     const { name, mobile, date, slot, workshopType } = userData;

// //     if (!name || !mobile || !date || !slot || !workshopType) {
// //       toast.error("Please fill in all details.");
// //       return;
// //     }
// //     if (!MOBILE_REGEX.test(mobile)) {
// //       toast.error("Invalid mobile number.");
// //       return;
// //     }

// //     const selectedSlot = slots[userData.slot];
// //     const slotRef = ref(db, `slots/${userData.date}/${userData.slot}`);

// //     try {
// //       await update(slotRef, {
// //         booked: selectedSlot.booked + 1,
// //         users: [...(selectedSlot.users || []), userEmail],
// //       });
// //       toast.success("Booking Confirmed!");
// //       setBookedSlot({ date: userData.date, slotName: selectedSlot.name });
// //     } catch (error) {
// //       console.error(error);
// //       toast.error("Booking failed. Try again.");
// //     }
// //   };

// //   const formatDisplayDate = (dateString) => {
// //     const [year, month, day] = dateString.split("-");
// //     return `${day}-${month}-${year}`;
// //   };

// //   const selectedWorkshop = useMemo(
// //     () => workshopOptions.find((w) => w.id === userData.workshopType),
// //     [userData.workshopType]
// //   );

// //   const step = useMemo(() => {
// //     if (!userData.workshopType) return 1;
// //     if (!userData.date) return 2;
// //     if (!userData.slot) return 3;
// //     return 4;
// //   }, [userData.workshopType, userData.date, userData.slot]);

// //   return (

    
// // <div className="min-h-screen bg-gradient-to-b from-orange-50 via-white to-white mt-10 pt-16 pb-24 lg:pb-14">

// //   {/* MOBILE FLOATING PROGRESS (Bottom) */}
// // {/* MOBILE FLOATING PROGRESS (Compact) */}
// // {!bookedSlot && (
// //   <div className="lg:hidden fixed bottom-3 left-3 right-3 z-50">
// //     <div className="rounded-2xl border border-orange-100 bg-white/95 backdrop-blur-xl shadow-lg">
// //       <div className="px-4 py-3 flex items-center justify-between gap-3">
// //         <div className="flex items-center gap-2 min-w-0">
// //           <div className="w-9 h-9 rounded-2xl bg-orange-50 border border-orange-100 flex items-center justify-center shrink-0">
// //             <Sparkles className="w-5 h-5 text-orange-600" />
// //           </div>

// //           <div className="min-w-0">
// //             <div className="text-[11px] font-bold text-gray-500">
// //               Step {step}/4 • {step === 1 ? "Workshop" : step === 2 ? "Date" : step === 3 ? "Slot" : "Confirm"}
// //             </div>
// //             <div className="text-sm font-extrabold text-gray-900 truncate">
// //               {selectedWorkshop?.title || "Choose a workshop"}
// //             </div>
// //           </div>
// //         </div>

// //         <div className="w-20">
// //           <div className="h-2 rounded-full bg-gray-100 overflow-hidden">
// //             <div
// //               className="h-full rounded-full bg-gradient-to-r from-orange-500 to-yellow-500 transition-all"
// //               style={{ width: `${(step / 4) * 100}%` }}
// //             />
// //           </div>
// //           <div className="mt-1 text-[10px] font-bold text-gray-400 text-right">
// //             {(step / 4) * 100}%
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   </div>
// // )}
     

// //         {/* Top Glow */}
// //       <div className="pointer-events-none absolute inset-x-0 top-0 h-64 bg-gradient-to-r from-orange-200/40 via-yellow-100/30 to-orange-200/40 blur-3xl" />

// //       {/* HERO */}
// //       <div className="relative">
// //         <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 pt-8 pb-10">
// //           <div className="rounded-3xl overflow-hidden shadow-xl border border-orange-100 bg-gradient-to-r from-orange-500 to-yellow-500">
// // <div className="px-5 py-7 sm:px-10 sm:py-12 text-white">
// //                 <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
// //                 <div>
// //                   <div className="inline-flex items-center gap-2 bg-white/15 px-3 py-1 rounded-full text-sm font-semibold">
// //                     <Sparkles className="w-4 h-4" />
// //                     Beekeeping Workshop Booking
// //                   </div>
// // <h1 className="mt-3 text-2xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight drop-shadow-sm">
// //                       Master the Art of Beekeeping
// //                   </h1>
// // <p className="mt-2 text-sm sm:text-lg text-orange-50/95 max-w-2xl">
// //                     From hive to honey — learn safely with expert guidance and real hives.
// //                   </p>

// // <div className="mt-5 hidden sm:flex flex-wrap gap-3">
// //                       <span className="inline-flex items-center gap-2 bg-white/15 px-4 py-2 rounded-full text-sm font-semibold">
// //                       <Hexagon className="w-4 h-4" /> Live Hives
// //                     </span>
// //                     <span className="inline-flex items-center gap-2 bg-white/15 px-4 py-2 rounded-full text-sm font-semibold">
// //                       <Shield className="w-4 h-4" /> Safe & Guided
// //                     </span>
// //                     <span className="inline-flex items-center gap-2 bg-white/15 px-4 py-2 rounded-full text-sm font-semibold">
// //                       <BadgeCheck className="w-4 h-4" /> Certificate
// //                     </span>
// //                   </div>
// //                 </div>

// //                 {/* Stepper */}
// // <div className="hidden lg:block bg-white/15 backdrop-blur-sm rounded-2xl p-5 border border-white/20 w-[420px]">                  <div className="text-sm font-bold tracking-wide text-white/90 mb-3">
// //                     Booking progress
// //                   </div>
// //                   <div className="grid grid-cols-4 gap-2">
// //                     {[1, 2, 3, 4].map((s) => (
// //                       <div key={s} className="flex flex-col items-center gap-2">
// //                         <div
// //                           className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-extrabold ${
// //                             step >= s
// //                               ? "bg-white text-orange-600"
// //                               : "bg-white/20 text-white"
// //                           }`}
// //                         >
// //                           {s}
// //                         </div>
// //                         <div className="text-[11px] text-white/90 text-center leading-tight">
// //                           {s === 1 && "Workshop"}
// //                           {s === 2 && "Date"}
// //                           {s === 3 && "Slot"}
// //                           {s === 4 && "Confirm"}
// //                         </div>
// //                       </div>
// //                     ))}
// //                   </div>
// //                   <div className="mt-4 h-2 bg-white/20 rounded-full overflow-hidden">
// //                     <div
// //                       className="h-full bg-white rounded-full transition-all"
// //                       style={{ width: `${(step / 4) * 100}%` }}
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 pb-14">
// //         {bookedSlot ? (
// //           <div className="bg-white rounded-3xl shadow-xl p-10 text-center border border-green-100">
// //             <div className="inline-flex items-center justify-center w-24 h-24 bg-green-50 rounded-full mb-6 border border-green-100">
// //               <CheckCircle className="w-12 h-12 text-green-600" />
// //             </div>
// //             <h2 className="text-3xl font-extrabold text-gray-900 mb-2">
// //               Booking Confirmed!
// //             </h2>
// //             <p className="text-gray-600 text-lg mb-8">
// //               See you on{" "}
// //               <span className="font-bold text-orange-600">
// //                 {formatDisplayDate(bookedSlot.date)}
// //               </span>{" "}
// //               at{" "}
// //               <span className="font-bold text-orange-600">{bookedSlot.slotName}</span>.
// //             </p>
// //             <button
// //               onClick={() => navigate("/dashboard")}
// //               className="px-8 py-3 bg-gray-900 text-white rounded-xl font-bold hover:bg-black transition shadow-lg"
// //             >
// //               Go to Dashboard
// //             </button>
// //           </div>
// //         ) : (
// //           <div className="">
// //             {/* LEFT: FORM */}
// //             <div className="lg:col-span-8">
// //               <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">
// //                 <div className="p-7 sm:p-10">
// //                   {/* Title */}
// //                   <div className="flex items-start justify-between gap-4 mb-8">
// //                     <div>
// //                       <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900">
// //                         Book your session
// //                       </h2>
// //                       <p className="mt-2 text-gray-600">
// //                         Fill details once. Pick workshop, date and a time slot.
// //                       </p>
// //                     </div>
// //                     <div className="hidden sm:flex items-center gap-2 rounded-2xl bg-orange-50 border border-orange-100 px-4 py-3">
// //                       <Shield className="w-5 h-5 text-orange-600" />
// //                       <span className="text-sm font-semibold text-orange-800">
// //                         Secure & Guided
// //                       </span>
// //                     </div>
// //                   </div>

// //                   <form onSubmit={handleSubmit} className="space-y-7">
// //                     {/* Participant Details */}
// //                     <section>
// //                       <div className="flex items-center gap-3 mb-5">
// //                         <div className="p-2 rounded-xl bg-orange-100 text-orange-700">
// //                           <User className="w-5 h-5" />
// //                         </div>
// //                         <div>
// //                           <h3 className="text-lg font-extrabold text-gray-900">
// //                             Participant details
// //                           </h3>
// //                           <p className="text-sm text-gray-500">
// //                             Used for contacting and confirming your booking.
// //                           </p>
// //                         </div>
// //                       </div>

// //                       <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
// //                         <div>
// //                           <label className="text-sm font-semibold text-gray-600 mb-2 block">
// //                             Full Name
// //                           </label>
// //                           <input
// //                             type="text"
// //                             name="name"
// //                             value={userData.name}
// //                             onChange={handleChange}
// //                             placeholder="e.g. Rahul Verma"
// //                             className="w-full px-4 py-3 rounded-2xl bg-gray-50 border border-gray-200 focus:bg-white focus:ring-2 focus:ring-orange-400 focus:border-transparent outline-none transition"
// //                             required
// //                           />
// //                         </div>

// //                         <div>
// //                           <label className="text-sm font-semibold text-gray-600 mb-2 block">
// //                             Age
// //                           </label>
// //                           <input
// //                             type="number"
// //                             name="age"
// //                             value={userData.age}
// //                             onChange={handleChange}
// //                             placeholder="e.g. 26"
// //                             className="w-full px-4 py-3 rounded-2xl bg-gray-50 border border-gray-200 focus:bg-white focus:ring-2 focus:ring-orange-400 focus:border-transparent outline-none transition"
// //                             required
// //                           />
// //                         </div>

// //                         <div>
// //                           <label className="text-sm font-semibold text-gray-600 mb-2 block">
// //                             Mobile Number
// //                           </label>
// //                           <div className="relative">
// //                             <Phone className="absolute left-4 top-3.5 w-5 h-5 text-gray-400" />
// //                             <input
// //                               type="tel"
// //                               name="mobile"
// //                               value={userData.mobile}
// //                               onChange={handleChange}
// //                               placeholder="9876543210"
// //                               className="w-full pl-12 pr-4 py-3 rounded-2xl bg-gray-50 border border-gray-200 focus:bg-white focus:ring-2 focus:ring-orange-400 focus:border-transparent outline-none transition"
// //                               required
// //                             />
// //                           </div>
// //                           <p className="mt-2 text-xs text-gray-500">
// //                             We’ll only use this for session coordination.
// //                           </p>
// //                         </div>

// //                         <div>
// //                           <label className="text-sm font-semibold text-gray-600 mb-2 block">
// //                             Email (Auto-filled)
// //                           </label>
// //                           <div className="relative">
// //                             <Mail className="absolute left-4 top-3.5 w-5 h-5 text-gray-400" />
// //                             <input
// //                               type="email"
// //                               value={userEmail || ""}
// //                               disabled
// //                               className="w-full pl-12 pr-4 py-3 rounded-2xl bg-gray-100 border border-gray-200 text-gray-500 cursor-not-allowed"
// //                             />
// //                           </div>
// //                         </div>
// //                       </div>
// //                     </section>

// //                     {/* Workshop Selection */}
// //                   {/* 2. Workshop Selection (Upgraded Cards + Feature Bullets) */}
// // <section>
// //   <h2 className="text-2xl font-extrabold text-gray-900 flex items-center mb-2">
// //     <span className="bg-orange-100 text-orange-700 p-2 rounded-2xl mr-3">
// //       <Star className="w-6 h-6" />
// //     </span>
// //     Select workshop type
// //   </h2>
// //   <p className="text-gray-600 mb-6">
// //     Choose what fits your goal. You can’t double-book slots.
// //   </p>

// //   <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
// //     {workshopOptions.map((option) => {
// //       const isSelected = userData.workshopType === option.id;

// //       const toneStyles =
// //         option.tone === "beginner"
// //           ? {
// //               card:
// //                 "bg-gradient-to-b from-orange-50 to-white border-orange-200 hover:border-orange-300",
// //               pill: "bg-orange-600 text-white",
// //               badge: "bg-yellow-100 text-yellow-900",
// //               check: "text-orange-600",
// //             }
// //           : option.tone === "pro"
// //           ? {
// //               card:
// //                 "bg-gradient-to-b from-slate-50 to-white border-slate-200 hover:border-slate-300",
// //               pill: "bg-slate-900 text-white",
// //               badge: "bg-yellow-100 text-yellow-900",
// //               check: "text-slate-900",
// //             }
// //           : {
// //               card: "bg-white border-gray-200 hover:border-orange-200",
// //               pill: "bg-slate-900 text-white",
// //               badge: "bg-gray-100 text-gray-800",
// //               check: "text-orange-600",
// //             };

// //       return (
// //         <button
// //           key={option.id}
// //           type="button"
// //           onClick={() => handleWorkshopSelect(option.id)}
// //           className={[
// //             "relative text-left rounded-3xl p-6 border transition-all duration-200",
// //             "hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0",
// //             toneStyles.card,
// //             isSelected ? "ring-2 ring-orange-500 border-orange-300 shadow-lg" : "",
// //           ].join(" ")}
// //         >
// //           {/* Top row: label + price pill */}
// //           <div className="flex items-start justify-between gap-4">
// //             <div>
// //               <div className="text-xs font-extrabold tracking-wide text-gray-500 uppercase">
// //                 {option.typeLabel}
// //               </div>

// //               {option.badge && (
// //                 <span
// //                   className={[
// //                     "inline-flex items-center gap-2 mt-3 px-3 py-1 rounded-full text-xs font-extrabold",
// //                     toneStyles.badge,
// //                   ].join(" ")}
// //                 >
// //                   <Sparkles className="w-4 h-4" />
// //                   {option.badge}
// //                 </span>
// //               )}
// //             </div>

// //             <div className="flex flex-col items-end">
// //               <span
// //                 className={[
// //                   "px-4 py-2 rounded-full text-sm font-extrabold shadow-sm",
// //                   toneStyles.pill,
// //                 ].join(" ")}
// //               >
// //                 {option.price}
// //               </span>
// //               <span className="text-[11px] mt-1 text-gray-500 font-semibold">
// //                 {option.priceNote}
// //               </span>
// //             </div>
// //           </div>

// //           {/* Title */}
// //           <h3 className="mt-5 text-2xl font-extrabold text-gray-900 leading-tight">
// //             {option.title}
// //           </h3>

// //           {/* Points */}
// //          <ul className="mt-4 space-y-2.5">
// //   {(option.points.slice(0, 4)).map((p, idx) => (
// //     <li key={idx} className="flex items-start gap-2.5 text-gray-700">
// //       <CheckCircle className={`w-5 h-5 mt-0.5 ${toneStyles.check}`} />
// //       <span className="text-sm font-medium">{p}</span>
// //     </li>
// //   ))}

// //   {option.points.length > 4 && (
// //     <li className="text-sm font-semibold text-gray-500 pl-7">
// //       +{option.points.length - 4} more
// //     </li>
// //   )}
// // </ul>

// //           {/* Bottom: Selected / CTA */}
// //           <div className="mt-6 flex items-center justify-between">
// //             {isSelected ? (
// //               <div className="inline-flex items-center gap-2 text-sm font-extrabold text-orange-700">
// //                 <CheckCircle className="w-5 h-5" />
// //                 Selected
// //               </div>
// //             ) : (
// //               <div className="text-sm font-semibold text-gray-500">
// //                 Tap to select
// //               </div>
// //             )}

// //             <span
// //               className={[
// //                 "inline-flex items-center gap-2 px-4 py-2 rounded-2xl text-sm font-extrabold",
// //                 isSelected
// //                   ? "bg-orange-600 text-white"
// //                   : "bg-gray-900 text-white",
// //               ].join(" ")}
// //             >
// //               {option.cta}
// //               <ChevronRight className="w-4 h-4" />
// //             </span>
// //           </div>

// //           {/* Subtle selected border glow */}
// //           {isSelected && (
// //             <div className="pointer-events-none absolute inset-0 rounded-3xl ring-2 ring-orange-500/40" />
// //           )}
// //         </button>
// //       );
// //     })}
// //   </div>
// // </section>

// //                     {/* Schedule */}
// //                     {userData.workshopType && (
// //                       <section className="animate-in fade-in slide-in-from-bottom-4 duration-500">
// //                         <div className="flex items-center gap-3 mb-5">
// //                           <div className="p-2 rounded-xl bg-orange-100 text-orange-700">
// //                             <Calendar className="w-5 h-5" />
// //                           </div>
// //                           <div>
// //                             <h3 className="text-lg font-extrabold text-gray-900">
// //                               Schedule session
// //                             </h3>
// //                             <p className="text-sm text-gray-500">
// //                               Pick a date first, then choose an available time slot.
// //                             </p>
// //                           </div>
// //                         </div>

// //                         {/* Dates */}
// //                         <div className="mb-6">
// //                           <div className="flex items-center justify-between mb-3">
// //                             <label className="text-xs font-extrabold text-gray-500 uppercase tracking-wider">
// //                               Available Dates
// //                             </label>
// //                             {userData.date && (
// //                               <span className="text-xs font-bold text-gray-500">
// //                                 Selected:{" "}
// //                                 <span className="text-gray-900">
// //                                   {formatDisplayDate(userData.date)}
// //                                 </span>
// //                               </span>
// //                             )}
// //                           </div>

// //                           <div className="flex flex-wrap gap-3">
// //                             {loading ? (
// //                               <div className="text-gray-400 text-sm">
// //                                 Loading calendar...
// //                               </div>
// //                             ) : dates.length > 0 ? (
// //                               dates.map((date) => (
// //                                 <button
// //                                   key={date}
// //                                   type="button"
// //                                   onClick={() => {
// //                                     setUserData((p) => ({ ...p, date, slot: "" }));
// //                                     fetchSlotsForDate(date);
// //                                   }}
// //                                   className={`px-5 py-3 rounded-2xl text-sm font-extrabold border transition-all ${
// //                                     userData.date === date
// //                                       ? "bg-gray-900 text-white border-gray-900 shadow-lg"
// //                                       : "bg-white text-gray-700 border-gray-200 hover:border-orange-300 hover:shadow-sm"
// //                                   }`}
// //                                 >
// //                                   {formatDisplayDate(date)}
// //                                 </button>
// //                               ))
// //                             ) : (
// //                               <div className="text-red-400 text-sm flex items-center">
// //                                 <Info className="w-4 h-4 mr-2" />
// //                                 No dates available right now.
// //                               </div>
// //                             )}
// //                           </div>
// //                         </div>

// //                         {/* Slots */}
// //                         {userData.date && (
// //                           <div>
// //                             <div className="flex items-center justify-between mb-3">
// //                               <label className="text-xs font-extrabold text-gray-500 uppercase tracking-wider">
// //                                 Available Time Slots
// //                               </label>
// //                               <span className="text-xs text-gray-500">
// //                                 Tap a slot to select
// //                               </span>
// //                             </div>

// //                             {Object.keys(slots).length === 0 ? (
// //                               <div className="rounded-2xl border border-gray-200 bg-gray-50 p-5 text-sm text-gray-600 flex items-start gap-3">
// //                                 <Info className="w-5 h-5 text-gray-400 mt-0.5" />
// //                                 <div>
// //                                   <div className="font-bold text-gray-900">
// //                                     No slots found for this date
// //                                   </div>
// //                                   <div className="text-gray-600">
// //                                     Try another date or check back later.
// //                                   </div>
// //                                 </div>
// //                               </div>
// //                             ) : (
// //                               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
// //                                 {Object.entries(slots).map(([key, slot]) => {
// //                                   const isFull = slot.booked >= slot.limit;
// //                                   const isSelected = userData.slot === key;
// //                                   const remaining = Math.max(
// //                                     0,
// //                                     (slot.limit || 0) - (slot.booked || 0)
// //                                   );
// //                                   const pct =
// //                                     slot.limit > 0
// //                                       ? Math.min(100, (slot.booked / slot.limit) * 100)
// //                                       : 0;

// //                                   return (
// //                                     <button
// //                                       key={key}
// //                                       type="button"
// //                                       disabled={isFull}
// //                                       onClick={() => setUserData({ ...userData, slot: key })}
// //                                       className={`rounded-2xl border p-4 text-left transition-all ${
// //                                         isFull
// //                                           ? "bg-gray-50 border-gray-100 text-gray-300 cursor-not-allowed"
// //                                           : isSelected
// //                                           ? "bg-orange-500 border-orange-500 text-white shadow-md"
// //                                           : "bg-white border-gray-200 text-gray-800 hover:border-orange-300 hover:shadow-sm"
// //                                       }`}
// //                                     >
// //                                       <div className="flex items-center justify-between gap-3">
// //                                         <div className="flex items-center">
// //                                           <Clock
// //                                             className={`w-4 h-4 mr-2 ${
// //                                               isSelected ? "text-orange-100" : "text-gray-400"
// //                                             }`}
// //                                           />
// //                                           <span className="font-extrabold">{slot.name}</span>
// //                                         </div>

// //                                         <span
// //                                           className={`text-xs px-2 py-1 rounded-md font-extrabold ${
// //                                             isFull
// //                                               ? "bg-gray-100 text-gray-400"
// //                                               : isSelected
// //                                               ? "bg-white/20 text-white"
// //                                               : "bg-orange-100 text-orange-700"
// //                                           }`}
// //                                         >
// //                                           {isFull ? "FULL" : `${remaining} Left`}
// //                                         </span>
// //                                       </div>

// //                                       {/* Capacity bar */}
// //                                       <div
// //                                         className={`mt-3 h-2 rounded-full overflow-hidden ${
// //                                           isSelected ? "bg-white/20" : "bg-gray-100"
// //                                         }`}
// //                                       >
// //                                         <div
// //                                           className={`h-full ${
// //                                             isSelected ? "bg-white" : "bg-gray-900"
// //                                           }`}
// //                                           style={{ width: `${pct}%` }}
// //                                         />
// //                                       </div>

// //                                       <div
// //                                         className={`mt-2 text-xs font-semibold ${
// //                                           isSelected ? "text-orange-50" : "text-gray-500"
// //                                         }`}
// //                                       >
// //                                         {slot.booked}/{slot.limit} booked
// //                                       </div>
// //                                     </button>
// //                                   );
// //                                 })}
// //                               </div>
// //                             )}
// //                           </div>
// //                         )}
// //                       </section>
// //                     )}

// //                     {/* Submit */}
// //                     <section className="pt-2">
// //                       <button
// //                         type="submit"
// //                         disabled={!userData.slot || !userData.workshopType}
// //                         className={`w-full py-4 px-6 rounded-2xl font-extrabold text-lg flex items-center justify-center transition-all duration-300 shadow-xl ${
// //                           !userData.slot || !userData.workshopType
// //                             ? "bg-gray-200 text-gray-400 cursor-not-allowed"
// //                             : "bg-gradient-to-r from-orange-500 to-yellow-500 text-white hover:from-orange-600 hover:to-yellow-600 transform hover:-translate-y-0.5"
// //                         }`}
// //                       >
// //                         Confirm Booking <ChevronRight className="w-5 h-5 ml-2" />
// //                       </button>

// //                       <div className="mt-4 flex items-start gap-3 rounded-2xl border border-gray-100 bg-gray-50 p-4">
// //                         <Info className="w-5 h-5 text-gray-400 mt-0.5" />
// //                         <p className="text-xs text-gray-600">
// //                           Secure booking powered by <span className="font-bold">The Great Honey Co.</span> —
// //                           you’ll receive confirmation instantly once the slot is updated.
// //                         </p>
// //                       </div>
// //                     </section>
// //                   </form>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* RIGHT: SUMMARY / TRUST */}
           
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // }



// // import React, { useState, useEffect, useMemo } from "react";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import { ref, get, update } from "firebase/database";
// // import { getAuth, onAuthStateChanged } from "firebase/auth";
// // import { database as db } from "../FirebaseConfig";
// // import toast from "react-hot-toast";
// // import {
// //   Calendar,
// //   Clock,
// //   User,
// //   Phone,
// //   Mail,
// //   CheckCircle,
// //   Hexagon,
// //   Shield,
// //   Star,
// //   Info,
// //   ChevronRight,
// //   Sparkles,
// //   BadgeCheck,
// //   Zap,
// //   TrendingUp,
// //   MapPin,
// // } from "lucide-react";

// // export default function LearnBK() {
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const auth = getAuth();
// //   const MOBILE_REGEX = /^[6-9]\d{9}$/;

// //   const [userData, setUserData] = useState({
// //     name: "",
// //     mobile: "",
// //     age: "",
// //     workshopType: "",
// //     date: "",
// //     slot: "",
// //   });

// //   const [userEmail, setUserEmail] = useState(null);
// //   const [dates, setDates] = useState([]);
// //   const [slots, setSlots] = useState({});
// //   const [loading, setLoading] = useState(true);
// //   const [bookedSlot, setBookedSlot] = useState(null);

// //   const workshopOptions = [
// //     {
// //       id: "1-Day",
// //       typeLabel: "EXPERIENTIAL",
// //       title: "The Bee-Ginner Discovery",
// //       price: "₹1,999",
// //       badge: "Most Fun",
// //       color: "from-orange-400 to-yellow-500",
// //       features: ["Live Hive Opening", "Suit Provided", "Honey Tasting"],
// //     },
// //     {
// //       id: "5-Day",
// //       typeLabel: "PROFESSIONAL",
// //       title: "Master Beekeeper Boot Camp",
// //       price: "₹10,999",
// //       badge: "Career Track",
// //       color: "from-amber-600 to-orange-600",
// //       features: ["Business Setup", "Extraction Pro", "Free Starter Kit"],
// //     },
// //     {
// //       id: "Lecture",
// //       typeLabel: "THEORY",
// //       title: "The Science of Hives",
// //       price: "₹7,499",
// //       badge: "Deep Dive",
// //       color: "from-yellow-600 to-amber-700",
// //       features: ["Pest Management", "Biology Focus", "Digital Materials"],
// //     },
// //   ];

// //   useEffect(() => {
// //     const redirectPath = new URLSearchParams(location.search).get("redirect") || "/learn-beekeeping";
// //     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
// //       if (currentUser) {
// //         setUserEmail(currentUser.email);
// //         checkUserAlreadyBooked(currentUser.email);
// //       } else {
// //         navigate(`/login?redirect=${redirectPath}`);
// //       }
// //       fetchDates();
// //     });
// //     return () => unsubscribe();
// //   }, [navigate]);

// //   const fetchDates = async () => {
// //     const dateRef = ref(db, "slots");
// //     try {
// //       const snapshot = await get(dateRef);
// //       if (snapshot.exists()) {
// //         const allDates = snapshot.val();
// //         const currentDate = new Date();
// //         currentDate.setHours(0, 0, 0, 0);
// //         const futureDates = Object.keys(allDates).filter((dateString) => {
// //           const [year, month, day] = dateString.split("-").map(Number);
// //           const dateObj = new Date(year, month - 1, day);
// //           return dateObj >= currentDate;
// //         });
// //         setDates(futureDates.sort((a, b) => new Date(a) - new Date(b)));
// //       }
// //     } catch (error) {
// //       console.error(error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const checkUserAlreadyBooked = async (email) => {
// //     const dateRef = ref(db, "slots");
// //     try {
// //       const snapshot = await get(dateRef);
// //       if (snapshot.exists()) {
// //         const allSlots = snapshot.val();
// //         for (let date in allSlots) {
// //           for (let slotId in allSlots[date]) {
// //             if (allSlots[date][slotId].users?.includes(email)) {
// //               setBookedSlot({ date, slotName: allSlots[date][slotId].name });
// //               return true;
// //             }
// //           }
// //         }
// //       }
// //     } catch (error) {}
// //     return false;
// //   };

// //   const fetchSlotsForDate = async (selectedDate) => {
// //     if (!selectedDate) return;
// //     setUserData((prev) => ({ ...prev, slot: "", date: selectedDate }));
// //     const slotRef = ref(db, `slots/${selectedDate}`);
// //     try {
// //       const snapshot = await get(slotRef);
// //       if (snapshot.exists()) {
// //         setSlots(snapshot.val());
// //       }
// //     } catch (error) {
// //       setSlots({});
// //     }
// //   };

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     if (name === "mobile") {
// //       setUserData({ ...userData, [name]: value.replace(/\D/g, "").slice(0, 10) });
// //     } else {
// //       setUserData({ ...userData, [name]: value });
// //     }
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     if (!userData.slot) return toast.error("Please pick a time slot!");
    
// //     const selectedSlot = slots[userData.slot];
// //     const slotRef = ref(db, `slots/${userData.date}/${userData.slot}`);

// //     try {
// //       await update(slotRef, {
// //         booked: selectedSlot.booked + 1,
// //         users: [...(selectedSlot.users || []), userEmail],
// //       });
// //       toast.success("Welcome to the Hive! Booking Confirmed.");
// //       setBookedSlot({ date: userData.date, slotName: selectedSlot.name });
// //     } catch (error) {
// //       toast.error("Booking failed. The bees are busy, try again!");
// //     }
// //   };

// //   const step = useMemo(() => {
// //     if (!userData.workshopType) return 1;
// //     if (!userData.date) return 2;
// //     if (!userData.slot) return 3;
// //     return 4;
// //   }, [userData]);

// //   return (
// //     <div className="min-h-screen bg-[#FFFDF0] relative overflow-hidden font-sans mt-30">
// //       {/* BACKGROUND DECORATION */}
// //       <div className="absolute inset-0 z-0 opacity-10 pointer-events-none">
// //         <div className="absolute top-20 left-10"><Hexagon size={120} className="text-orange-400" /></div>
// //         <div className="absolute top-1/2 right-10"><Hexagon size={200} className="text-yellow-400" /></div>
// //         <div className="absolute bottom-10 left-1/4"><Hexagon size={80} className="text-orange-300" /></div>
// //       </div>

// //       <main className="relative z-10 max-w-7xl mx-auto px-4 pt-12 pb-24">
// //         {bookedSlot ? (
// //           /* CONFIRMATION UI */
// //           <div className="max-w-2xl mx-auto mt-20 text-center animate-in zoom-in duration-500">
// //              <div className="relative inline-block">
// //                 <div className="absolute inset-0 bg-green-400 blur-2xl opacity-20 animate-pulse"></div>
// //                 <div className="relative bg-white p-8 rounded-[40px] shadow-2xl border-4 border-green-500">
// //                     <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
// //                         <CheckCircle size={48} className="text-green-600" />
// //                     </div>
// //                     <h2 className="text-4xl font-black text-gray-900 mb-4">You're officially a future Beekeeper!</h2>
// //                     <p className="text-gray-600 mb-8 text-lg">We've reserved your smoker and suit for <br/>
// //                         <span className="font-black text-orange-600 underline">{bookedSlot.slotName}</span> on <span className="font-black text-orange-600">{bookedSlot.date}</span>
// //                     </p>
// //                     <button onClick={() => navigate('/dashboard')} className="w-full py-4 bg-gray-900 text-white rounded-2xl font-bold hover:bg-black transition-all shadow-xl">
// //                         View My Training Dashboard
// //                     </button>
// //                 </div>
// //              </div>
// //           </div>
// //         ) : (
// //           <div className="grid lg:grid-cols-12 gap-12">
            
// //             {/* LEFT: CONTENT & FORM */}
// //             <div className="lg:col-span-8 space-y-12">
              
// //               {/* HERO SECTION */}
// //               <section className="space-y-4">
// //                 <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-100 text-orange-700 text-xs font-black uppercase tracking-widest">
// //                   <Zap size={14} fill="currentColor" /> Limited Slots Available
// //                 </div>
// //                 <h1 className="text-5xl md:text-7xl font-black text-gray-900 leading-[0.9]">
// //                   Get Sticky. <br />
// //                   <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-yellow-500">Save the Bees.</span>
// //                 </h1>
// //                 <p className="text-xl text-gray-600 max-w-xl font-medium">
// //                   Don't just read about nature. Reach into a hive of 50,000 bees and feel the vibration of the planet.
// //                 </p>
// //               </section>

// //               <form onSubmit={handleSubmit} className="space-y-16">
                
// //                 {/* STEP 1: WORKSHOP CARDS */}
// //                 <section className="space-y-6">
// //                   <div className="flex items-end justify-between">
// //                     <h3 className="text-2xl font-black flex items-center gap-3 text-gray-900">
// //                       <span className="w-10 h-10 bg-orange-500 text-white rounded-xl flex items-center justify-center shadow-lg">1</span>
// //                       Choose Your Path
// //                     </h3>
// //                   </div>
                  
// //                   <div className="grid md:grid-cols-3 gap-6">
// //                     {workshopOptions.map((opt) => (
// //                       <div 
// //                         key={opt.id}
// //                         onClick={() => setUserData({...userData, workshopType: opt.id})}
// //                         className={`group relative cursor-pointer p-6 rounded-[32px] border-2 transition-all duration-500 ${
// //                           userData.workshopType === opt.id 
// //                           ? "bg-white border-orange-500 shadow-2xl -translate-y-2" 
// //                           : "bg-white/50 border-gray-100 hover:border-orange-200"
// //                         }`}
// //                       >
// //                         <div className={`absolute top-4 right-4 w-12 h-12 rounded-2xl bg-gradient-to-br ${opt.color} flex items-center justify-center text-white transition-transform group-hover:rotate-12`}>
// //                           <Hexagon fill="white" size={20} />
// //                         </div>
// //                         <div className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1">{opt.typeLabel}</div>
// //                         <h4 className="text-xl font-black text-gray-900 mb-4 leading-tight">{opt.title}</h4>
// //                         <div className="text-2xl font-black text-orange-600 mb-6">{opt.price}</div>
// //                         <ul className="space-y-2">
// //                           {opt.features.map(f => (
// //                             <li key={f} className="flex items-center gap-2 text-xs font-bold text-gray-500">
// //                               <CheckCircle size={14} className="text-green-500" /> {f}
// //                             </li>
// //                           ))}
// //                         </ul>
// //                         {userData.workshopType === opt.id && (
// //                           <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-orange-500 text-white text-[10px] font-black px-4 py-1 rounded-full shadow-lg">SELECTED</div>
// //                         )}
// //                       </div>
// //                     ))}
// //                   </div>
// //                 </section>

// //                 {/* STEP 2: USER INFO */}
// //                 {userData.workshopType && (
// //                    <section className="animate-in slide-in-from-bottom-10 duration-700 space-y-6">
// //                     <h3 className="text-2xl font-black flex items-center gap-3 text-gray-900">
// //                         <span className="w-10 h-10 bg-orange-500 text-white rounded-xl flex items-center justify-center shadow-lg">2</span>
// //                         Human Details
// //                     </h3>
// //                     <div className="grid md:grid-cols-2 gap-6 bg-white p-8 rounded-[40px] shadow-sm border border-orange-50">
// //                         <div className="space-y-2">
// //                             <label className="text-xs font-black text-gray-400 uppercase ml-2">Your Name</label>
// //                             <input type="text" name="name" onChange={handleChange} value={userData.name} required className="w-full bg-orange-50/50 border-0 rounded-2xl px-6 py-4 focus:ring-2 ring-orange-400 transition-all outline-none font-bold" placeholder="Rahul Reddy" />
// //                         </div>
// //                         <div className="space-y-2">
// //                             <label className="text-xs font-black text-gray-400 uppercase ml-2">WhatsApp Number</label>
// //                             <input type="tel" name="mobile" onChange={handleChange} value={userData.mobile} required className="w-full bg-orange-50/50 border-0 rounded-2xl px-6 py-4 focus:ring-2 ring-orange-400 transition-all outline-none font-bold" placeholder="9876543210" />
// //                         </div>
// //                     </div>
// //                    </section>
// //                 )}

// //                 {/* STEP 3: SCHEDULING */}
// //                 {userData.mobile.length === 10 && (
// //                    <section className="animate-in slide-in-from-bottom-10 duration-700 space-y-8">
// //                       <h3 className="text-2xl font-black flex items-center gap-3 text-gray-900">
// //                         <span className="w-10 h-10 bg-orange-500 text-white rounded-xl flex items-center justify-center shadow-lg">3</span>
// //                         Pick Your Moment
// //                       </h3>

// //                       {/* DATE PICKER */}
// //                       <div className="flex flex-wrap gap-3">
// //                          {dates.map(d => (
// //                            <button 
// //                             key={d} 
// //                             type="button" 
// //                             onClick={() => fetchSlotsForDate(d)}
// //                             className={`px-8 py-4 rounded-2xl font-black transition-all ${
// //                               userData.date === d ? "bg-gray-900 text-white scale-105 shadow-xl" : "bg-white border-2 border-gray-100 text-gray-400 hover:border-orange-200"
// //                             }`}
// //                            >
// //                              {d.split('-').reverse().slice(0,2).join('/')}
// //                            </button>
// //                          ))}
// //                       </div>

// //                       {/* SLOT PICKER */}
// //                       {userData.date && (
// //                         <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
// //                            {Object.entries(slots).map(([key, s]) => {
// //                              const isFull = s.booked >= s.limit;
// //                              const isSel = userData.slot === key;
// //                              return (
// //                                <button 
// //                                 key={key}
// //                                 type="button"
// //                                 disabled={isFull}
// //                                 onClick={() => setUserData({...userData, slot: key})}
// //                                 className={`relative p-4 rounded-3xl border-2 transition-all ${
// //                                   isFull ? "opacity-40 grayscale cursor-not-allowed" :
// //                                   isSel ? "bg-orange-500 border-orange-500 text-white shadow-lg" : "bg-white border-orange-100 hover:bg-orange-50"
// //                                 }`}
// //                                >
// //                                   <div className="text-sm font-black">{s.name}</div>
// //                                   <div className={`text-[10px] font-bold mt-1 ${isSel ? "text-orange-100" : "text-gray-400"}`}>
// //                                     {isFull ? "HOUSE FULL" : `${s.limit - s.booked} SPOTS LEFT`}
// //                                   </div>
// //                                </button>
// //                              )
// //                            })}
// //                         </div>
// //                       )}
// //                    </section>
// //                 )}

// //                 {/* FINAL CTA */}
// //                 {userData.slot && (
// //                   <div className="sticky bottom-10 z-30 animate-in fade-in slide-in-from-bottom-5">
// //                     <button type="submit" className="group w-full bg-gray-900 text-white p-2 rounded-[32px] shadow-2xl hover:scale-[1.02] transition-all">
// //                       <div className="flex items-center justify-between bg-orange-500 p-6 rounded-[28px]">
// //                         <div className="text-left">
// //                            <div className="text-xs font-black uppercase opacity-80">Ready to fly?</div>
// //                            <div className="text-2xl font-black">Confirm Training Session</div>
// //                         </div>
// //                         <div className="w-16 h-16 bg-white text-orange-600 rounded-2xl flex items-center justify-center group-hover:rotate-90 transition-transform">
// //                            <ChevronRight size={32} />
// //                         </div>
// //                       </div>
// //                     </button>
// //                   </div>
// //                 )}
// //               </form>
// //             </div>

// //             {/* RIGHT: FLOATING SIZZLE PANEL */}
// //             <div className="lg:col-span-4 hidden lg:block">
// //               <div className="sticky top-32 space-y-6">
                 
// //                  {/* LIVE STATUS CARD */}
// //                  <div className="bg-white p-6 rounded-[32px] shadow-xl border border-orange-100 relative overflow-hidden">
// //                     <div className="absolute top-0 right-0 w-24 h-24 bg-orange-50 rounded-full -mr-10 -mt-10"></div>
// //                     <div className="flex items-center gap-3 mb-6">
// //                         <div className="w-3 h-3 bg-red-500 rounded-full animate-ping"></div>
// //                         <span className="text-xs font-black text-gray-400 uppercase tracking-widest">Live Updates</span>
// //                     </div>
// //                     <div className="space-y-4">
// //                         <div className="flex items-center justify-between">
// //                             <span className="text-sm font-bold text-gray-600">Active Learners</span>
// //                             <span className="font-black text-gray-900">124 Today</span>
// //                         </div>
// //                         <div className="flex items-center justify-between">
// //                             <span className="text-sm font-bold text-gray-600">Hive Health</span>
// //                             <span className="text-green-600 font-black">Optimal 100%</span>
// //                         </div>
// //                     </div>
// //                  </div>

// //                  {/* TRUST CARD */}
// //                  <div className="bg-gradient-to-br from-gray-900 to-black p-8 rounded-[40px] text-white shadow-2xl relative">
// //                     <Star className="absolute top-6 right-6 text-yellow-500 fill-current" />
// //                     <h4 className="text-2xl font-black mb-4 leading-tight">Safety First, <br/> Honey Second.</h4>
// //                     <p className="text-gray-400 text-sm mb-6 leading-relaxed">
// //                         We use professional-grade sting-proof ventilated suits. 
// //                         <strong> Zero stings reported</strong> in our last 50 workshops.
// //                     </p>
// //                     <div className="flex -space-x-3">
// //                         {[1,2,3,4].map(i => (
// //                             <div key={i} className="w-10 h-10 rounded-full border-2 border-gray-900 bg-orange-100 flex items-center justify-center overflow-hidden">
// //                                 <img src={`https://i.pravatar.cc/100?u=${i}`} alt="user" />
// //                             </div>
// //                         ))}
// //                         <div className="w-10 h-10 rounded-full border-2 border-gray-900 bg-orange-500 flex items-center justify-center text-[10px] font-black">+1k</div>
// //                     </div>
// //                     <div className="mt-4 text-xs font-bold text-gray-500">Joined by nature lovers from Hyderabad</div>
// //                  </div>

// //                  {/* LOCATION CARD */}
// //                  <div className="bg-orange-50 p-6 rounded-[32px] border border-orange-100">
// //                     <div className="flex items-start gap-4">
// //                         <div className="p-3 bg-white rounded-2xl shadow-sm text-orange-600">
// //                             <MapPin size={24} />
// //                         </div>
// //                         <div>
// //                             <div className="text-xs font-black text-gray-400 uppercase">Training Hive</div>
// //                             <div className="text-sm font-black text-gray-900">VNR VJIET Apiary, Hyderabad</div>
// //                             <div className="text-[10px] font-bold text-orange-600 mt-1">Google Maps Link sent after booking</div>
// //                         </div>
// //                     </div>
// //                  </div>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //       </main>

// //       {/* MOBILE FLOATING CTA HELPER */}
// //       {!bookedSlot && step < 4 && (
// //         <div className="lg:hidden fixed bottom-6 left-6 right-6 z-50 animate-in slide-in-from-bottom-20">
// //              <div className="bg-white/90 backdrop-blur-xl p-4 rounded-3xl shadow-2xl border border-orange-100 flex items-center justify-between">
// //                 <div>
// //                     <div className="text-[10px] font-black text-gray-400 uppercase">Step {step} of 4</div>
// //                     <div className="text-sm font-black text-gray-900">
// //                         {step === 1 ? "Pick a Path" : step === 2 ? "Enter Details" : "Select Time"}
// //                     </div>
// //                 </div>
// //                 <div className="w-12 h-12 bg-orange-500 rounded-2xl flex items-center justify-center text-white">
// //                     <TrendingUp size={20} />
// //                 </div>
// //              </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }







// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { ref, get, update } from "firebase/database";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
// import { database as db } from "../FirebaseConfig";
// import { motion, AnimatePresence } from "framer-motion";
// import toast from "react-hot-toast";
// import { 
//   CheckCircle, Hexagon, Shield, BookOpen, 
//   ArrowRight, MousePointerClick, User, Phone, Leaf, Star
// } from "lucide-react";

// export default function LearnBK() {
//   const navigate = useNavigate();
//   const auth = getAuth();
  
//   const [userData, setUserData] = useState({ name: "", mobile: "", date: "", slot: "" });
//   const [userEmail, setUserEmail] = useState(null);
//   const [dates, setDates] = useState([]);
//   const [slots, setSlots] = useState({});
//   const [bookedSlot, setBookedSlot] = useState(null);

//   // Animation Variants
//   const fadeInUp = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
//   };

//   const staggerContainer = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
//   };

//   const syllabus = [
//     { day: 1, theme: "Introduction to Apiculture", desc: "Apiculture, beekeeper, bee types, equipment, feeding, hive intro." },
//     { day: 2, theme: "Hive Life & Wild Honey", desc: "Wild honey hunting, species, comb observation, colony organisation, bee castes." },
//     { day: 3, theme: "Life Cycles & Queens", desc: "Egg stages, lifetimes, timelines, queen introduction, swarming." },
//     { day: 4, theme: "Records & Products", desc: "Seasonal maintenance, field setup, aerial survey, honey grades, hive products." },
//     { day: 5, theme: "Business & Sustainability", desc: "Costing, diseases, pricing strategy, government schemes (NABARD, FSSAI)." }
//   ];

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
//       if (currentUser) {
//         setUserEmail(currentUser.email);
//         checkUserAlreadyBooked(currentUser.email);
//       }
//       fetchDates();
//     });
//     return () => unsubscribe();
//   }, []);

//   const fetchDates = async () => {
//     const dateRef = ref(db, "slots");
//     try {
//       const snapshot = await get(dateRef);
//       if (snapshot.exists()) {
//         const allDates = snapshot.val();
//         const currentDate = new Date();
//         currentDate.setHours(0, 0, 0, 0);
        
//         const futureDates = Object.keys(allDates).filter(dateString => {
//           const [year, month, day] = dateString.split("-").map(Number);
//           const dateObj = new Date(year, month - 1, day);
//           return dateObj >= currentDate;
//         });
        
//         setDates(futureDates.sort((a, b) => new Date(a) - new Date(b)));
//       }
//     } catch (e) { toast.error("Error loading calendar"); }
//   };

//   const checkUserAlreadyBooked = async (email) => {
//     const snapshot = await get(ref(db, "slots"));
//     if (snapshot.exists()) {
//       const all = snapshot.val();
//       for (let d in all) {
//         for (let s in all[d]) {
//           if (all[d][s].users?.includes(email)) {
//             setBookedSlot({ date: d, slotName: all[d][s].name });
//             return true;
//           }
//         }
//       }
//     }
//     return false;
//   };

//   const fetchSlotsForDate = (d) => {
//     setUserData(prev => ({ ...prev, date: d, slot: "" }));
//     get(ref(db, `slots/${d}`)).then(snap => setSlots(snap.val() || {}));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "mobile") {
//       setUserData({ ...userData, [name]: value.replace(/\D/g, "").slice(0, 10) });
//     } else {
//       setUserData({ ...userData, [name]: value });
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!userData.name || !userData.mobile || !userData.date || !userData.slot) {
//       return toast.error("Please fill out all details and pick a slot.");
//     }
//     if (userData.mobile.length < 10) {
//       return toast.error("Please enter a valid 10-digit mobile number.");
//     }

//     const selectedSlot = slots[userData.slot];
//     const slotRef = ref(db, `slots/${userData.date}/${userData.slot}`);

//     try {
//       await update(slotRef, {
//         booked: selectedSlot.booked + 1,
//         users: [...(selectedSlot.users || []), userEmail],
//       });
//       toast.success("Slot booked successfully!");
//       setBookedSlot({ date: userData.date, slotName: selectedSlot.name });
//     } catch (error) {
//       toast.error("Failed to book the slot. Please try again.");
//     }
//   };

//   // Calculate current step for mobile floating CTA
//   const currentStep = !userData.name || userData.mobile.length < 10 ? 1 : !userData.date ? 2 : !userData.slot ? 3 : 4;

//   return (
//     // offset for 40px navbar
//     <div className="mt-[40px] min-h-screen bg-[#F7F3EB] text-[#2F2F2F] selection:bg-orange-200 overflow-x-hidden">
      
//       {/* HERO SECTION */}
//       <section className="relative h-[85vh] md:h-[90vh] w-full flex items-center justify-center overflow-hidden">
//         <motion.video 
//           initial={{ scale: 1.1 }}
//           animate={{ scale: 1 }}
//           transition={{ duration: 1.5 }}
//           autoPlay loop muted playsInline 
//           className="absolute z-0 w-full h-full object-cover"
//         >
//           {/* Replace with your actual video source */}
//           <source src="YOUR_VIDEO_URL_HERE.mp4" type="video/mp4" />
//         </motion.video>
        
//         <div className="absolute z-10 inset-0 bg-gradient-to-b from-black/70 via-black/40 to-transparent" />

//         <div className="relative z-20 text-center px-4 md:px-6 max-w-5xl w-full">
//           <motion.div initial="hidden" animate="visible" variants={fadeInUp}>
//             {/* Fluid typography for extreme mobile responsiveness */}
//             <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white mb-4 sm:mb-6 leading-[1.1] md:leading-[0.9] tracking-tight drop-shadow-lg">
//               BEE THE <br className="hidden sm:block"/><span className="text-orange-400">CHANGE.</span>
//             </h1>
//             <p className="text-base sm:text-lg md:text-2xl text-white/90 font-medium mb-8 md:mb-10 max-w-2xl mx-auto drop-shadow-md px-2">
//               A 5-Day immersive masterclass in professional apiculture, honey extraction, and sustainable hive management.
//             </p>
//             <motion.button 
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onClick={() => document.getElementById('booking-form').scrollIntoView({ behavior: 'smooth' })}
//               className="w-[90%] sm:w-auto bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 md:px-10 md:py-5 rounded-full font-black text-lg md:text-xl shadow-2xl flex items-center justify-center gap-3 mx-auto"
//             >
//               Apply Now <ArrowRight size={24} />
//             </motion.button>
//           </motion.div>
//         </div>
        
//         <motion.div 
//           animate={{ y: [0, 10, 0] }} 
//           transition={{ repeat: Infinity, duration: 2 }}
//           className="absolute bottom-8 z-20 text-white opacity-50 hidden sm:block"
//         >
//           <MousePointerClick size={32} />
//         </motion.div>
//       </section>

//       {/* STORY & BENEFITS SECTION */}
//       <section className="py-16 md:py-24 px-4 sm:px-6 max-w-7xl mx-auto border-b border-orange-200/50">
//         <motion.div 
//           initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} variants={staggerContainer}
//           className="grid lg:grid-cols-2 gap-10 md:gap-16 items-center"
//         >
//           <motion.div variants={fadeInUp} className="space-y-4 md:space-y-6">
//             <div className="w-12 h-12 md:w-16 md:h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-4 md:mb-6">
//               <Leaf className="text-orange-600 w-6 h-6 md:w-8 md:h-8" />
//             </div>
//             <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 leading-tight">
//               Why We Started This
//             </h2>
//             <p className="text-base md:text-lg font-medium text-gray-600 leading-relaxed">
//               We started this initiative after realising that many farmers lacked access to proper, structured training in beekeeping. While beekeeping has strong income potential, most were left to learn through trial and error.
//             </p>
//             <p className="text-base md:text-lg font-medium text-gray-600 leading-relaxed">
//               This program bridges that gap through practical, hands-on training helping farmers not only earn from honey and other hive by-products as a secondary income, but also improve crop yields through effective cross-pollination.
//             </p>
//           </motion.div>
          
//           <motion.div variants={fadeInUp} className="space-y-6 bg-white p-6 md:p-10 rounded-[24px] md:rounded-[40px] shadow-xl border border-orange-100">
//             <h3 className="text-xl md:text-2xl font-black flex items-center gap-3">
//               <Star className="text-orange-500 shrink-0" /> What You’ll Gain
//             </h3>
//             <ul className="space-y-3 md:space-y-4">
//               {[
//                 "Hands-on experience working with live hives",
//                 "Confidence to handle bees safely and effectively",
//                 "Step-by-step guidance to start your own apiary",
//                 "Practical skills in honey extraction and processing",
//                 "Knowledge to turn beekeeping into a sustainable income"
//               ].map((item, i) => (
//                 <li key={i} className="flex items-start gap-3 md:gap-4">
//                   <CheckCircle className="text-green-500 w-5 h-5 md:w-6 md:h-6 shrink-0 mt-0.5" />
//                   <span className="font-bold text-sm md:text-base text-gray-700">{item}</span>
//                 </li>
//               ))}
//             </ul>
//           </motion.div>
//         </motion.div>
//       </section>

//       {/* SYLLABUS GRID */}
//       <section className="py-16 md:py-24 px-4 sm:px-6 max-w-7xl mx-auto">
//         <div className="text-center mb-10 md:mb-16">
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-3 md:mb-4">5-Day Workshop Plan</h2>
//           <p className="font-bold text-sm md:text-base text-gray-500 px-4">From basic biology to running a sustainable honey business.</p>
//         </div>
//         <motion.div 
//           initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} variants={staggerContainer}
//           className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-6"
//         >
//           {syllabus.map((item) => (
//             <motion.div 
//               key={item.day} variants={fadeInUp}
//               className="group bg-white p-6 md:p-8 rounded-[24px] md:rounded-[32px] shadow-sm hover:shadow-xl transition-all border border-orange-100 hover:border-orange-500"
//             >
//               <div className="w-10 h-10 md:w-12 md:h-12 bg-orange-100 rounded-xl md:rounded-2xl flex items-center justify-center text-orange-600 font-black mb-4 md:mb-6 group-hover:bg-orange-500 group-hover:text-white transition-colors">
//                 0{item.day}
//               </div>
//               <h4 className="text-lg md:text-xl font-black mb-2 md:mb-3">{item.theme}</h4>
//               <p className="text-xs md:text-sm font-medium text-gray-500 leading-relaxed">
//                 {item.desc}
//               </p>
//             </motion.div>
//           ))}
//         </motion.div>
//       </section>

//       {/* BOOKING SECTION */}
//       <section id="booking-form" className="py-12 md:py-20 px-4 md:px-6">
//         <div className="max-w-6xl mx-auto">
//           <motion.div 
//             initial={{ opacity: 0, scale: 0.95 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             viewport={{ once: true }}
//             className="bg-white rounded-[32px] md:rounded-[60px] shadow-2xl overflow-hidden border border-orange-100 flex flex-col lg:flex-row"
//           >
//             {/* Form Area */}
//             <div className="w-full lg:w-3/5 p-6 sm:p-10 md:p-16">
//               <h2 className="text-3xl sm:text-4xl md:text-5xl font-black mb-6 md:mb-8 flex items-center gap-3 md:gap-4">
//                 Reserve Slot <Hexagon fill="#f97316" className="text-orange-500 animate-pulse w-8 h-8 md:w-10 md:h-10" />
//               </h2>

//               {bookedSlot ? (
//                 <div className="py-8 md:py-10 text-center animate-in zoom-in duration-500">
//                   <CheckCircle className="text-green-500 mx-auto mb-4 w-16 h-16 md:w-20 md:h-20" />
//                   <h3 className="text-2xl md:text-3xl font-black">Registration Confirmed</h3>
//                   <p className="font-bold text-gray-500 mt-3 md:mt-4 text-sm md:text-lg">
//                     You are scheduled for <br className="sm:hidden" />
//                     <span className="text-orange-500">{bookedSlot.slotName}</span> on <span className="text-orange-500">{bookedSlot.date}</span>.
//                   </p>
//                 </div>
//               ) : (
//                 <form onSubmit={handleSubmit} className="space-y-8 md:space-y-10">
                  
//                   {/* Step 1: User Details */}
//                   <div className="space-y-3 md:space-y-4">
//                     <p className="text-[10px] md:text-xs font-black uppercase tracking-widest text-orange-500 flex items-center gap-2">
//                       <span className="bg-orange-100 px-2 py-0.5 rounded text-orange-600">1</span> Your Details
//                     </p>
//                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
//                       <div className="relative">
//                         <User className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
//                         <input 
//                           type="text" name="name" placeholder="Full Name" required
//                           value={userData.name} onChange={handleChange}
//                           className="w-full pl-11 pr-4 py-3.5 md:py-4 rounded-xl md:rounded-2xl bg-[#F7F3EB] border-2 border-transparent focus:border-orange-500 text-sm md:text-base font-bold outline-none transition-all"
//                         />
//                       </div>
//                       <div className="relative">
//                         <Phone className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
//                         <input 
//                           type="tel" name="mobile" placeholder="WhatsApp Number" required
//                           value={userData.mobile} onChange={handleChange}
//                           className="w-full pl-11 pr-4 py-3.5 md:py-4 rounded-xl md:rounded-2xl bg-[#F7F3EB] border-2 border-transparent focus:border-orange-500 text-sm md:text-base font-bold outline-none transition-all"
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   {/* Step 2: Date Selection */}
//                   <div className="space-y-3 md:space-y-4">
//                     <p className="text-[10px] md:text-xs font-black uppercase tracking-widest text-orange-500 flex items-center gap-2">
//                       <span className="bg-orange-100 px-2 py-0.5 rounded text-orange-600">2</span> Select Date
//                     </p>
//                     {dates.length === 0 ? (
//                       <p className="text-gray-500 font-bold text-sm">Loading dates...</p>
//                     ) : (
//                       <div className="flex flex-wrap gap-2 md:gap-3">
//                         {dates.map(d => (
//                           <motion.button 
//                             key={d} type="button" whileTap={{ scale: 0.95 }}
//                             onClick={() => fetchSlotsForDate(d)}
//                             className={`flex-1 sm:flex-none min-w-[120px] px-4 md:px-6 py-3 md:py-4 rounded-xl md:rounded-2xl text-sm md:text-base font-black transition-all ${
//                               userData.date === d ? "bg-orange-500 text-white shadow-lg" : "bg-orange-50 text-orange-700 hover:bg-orange-100 border border-orange-100"
//                             }`}>
//                             {new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}
//                           </motion.button>
//                         ))}
//                       </div>
//                     )}
//                   </div>

//                   {/* Step 3: Slot Selection */}
//                   <AnimatePresence mode="wait">
//                     {userData.date && (
//                       <motion.div 
//                         initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
//                         className="space-y-3 md:space-y-4"
//                       >
//                         <p className="text-[10px] md:text-xs font-black uppercase tracking-widest text-orange-500 flex items-center gap-2">
//                            <span className="bg-orange-100 px-2 py-0.5 rounded text-orange-600">3</span> Pick a Session
//                         </p>
//                         <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
//                           {Object.entries(slots).map(([key, s]) => {
//                             const isFull = s.booked >= s.limit;
//                             return (
//                               <button 
//                                 key={key} type="button" disabled={isFull}
//                                 onClick={() => setUserData({...userData, slot: key})}
//                                 className={`p-4 md:p-6 rounded-xl md:rounded-[24px] border-2 text-left transition-all ${
//                                   isFull ? "opacity-50 bg-gray-50 cursor-not-allowed border-gray-200" :
//                                   userData.slot === key ? "bg-gray-900 border-gray-900 text-white shadow-xl" : "border-gray-200 hover:border-orange-300 bg-white"
//                                 }`}>
//                                 <div className="font-black text-base md:text-lg">{s.name}</div>
//                                 <div className={`text-[10px] md:text-xs font-bold uppercase mt-1 md:mt-2 ${isFull ? "text-red-500" : "opacity-60"}`}>
//                                   {isFull ? "Session Full" : `${s.limit - s.booked} spots available`}
//                                 </div>
//                               </button>
//                             )
//                           })}
//                         </div>
//                       </motion.div>
//                     )}
//                   </AnimatePresence>

//                   {/* Submit Button */}
//                   <button type="submit" className="w-full mt-2 py-4 md:py-5 bg-orange-500 hover:bg-orange-600 text-white rounded-xl md:rounded-[24px] font-black text-lg md:text-xl shadow-xl shadow-orange-500/20 transition-all hover:-translate-y-1 active:translate-y-0">
//                     Complete Registration
//                   </button>
//                 </form>
//               )}
//             </div>

//             {/* Sidebar Info - Adapts to bottom on mobile */}
//             <div className="w-full lg:w-2/5 bg-gray-900 p-8 sm:p-10 md:p-16 text-white flex flex-col justify-between">
//               <div>
//                 <h4 className="text-orange-400 font-black text-xs md:text-sm uppercase tracking-widest mb-6 md:mb-10 flex items-center gap-2">
//                    Investment Outline
//                 </h4>
//                 <div className="space-y-4 md:space-y-6 mb-8 md:mb-12">
//                   <div className="flex justify-between items-end border-b border-gray-800 pb-3 md:pb-0 md:border-none">
//                     <span className="text-sm md:text-base font-bold opacity-60">Workshop Fee</span>
//                     <span className="text-xl md:text-2xl font-black">₹7,000</span>
//                   </div>
//                   <div className="flex justify-between items-end border-b border-gray-800 pb-3 md:pb-0 md:border-none">
//                     <span className="text-sm md:text-base font-bold opacity-60">Add-on Hive Kit</span>
//                     <span className="text-xl md:text-2xl font-black">₹5,000</span>
//                   </div>
//                   <div className="hidden md:block h-px bg-white/10 my-4" />
//                   <div className="flex justify-between items-end pt-2 md:pt-0">
//                     <span className="font-black text-orange-400 text-base md:text-lg">Total Overall</span>
//                     <span className="text-3xl md:text-5xl font-black text-white">₹12,000</span>
//                   </div>
//                 </div>
//               </div>

//               <div className="space-y-3 md:space-y-4">
//                 <div className="flex items-center gap-3 md:gap-4 bg-white/5 p-3 md:p-4 rounded-xl md:rounded-2xl border border-white/10 backdrop-blur-sm">
//                   <Shield className="text-orange-400 w-5 h-5 md:w-6 md:h-6 shrink-0" />
//                   <span className="text-xs md:text-sm font-bold">Safety Gear Provided</span>
//                 </div>
//                 <div className="flex items-center gap-3 md:gap-4 bg-white/5 p-3 md:p-4 rounded-xl md:rounded-2xl border border-white/10 backdrop-blur-sm">
//                   <BookOpen className="text-orange-400 w-5 h-5 md:w-6 md:h-6 shrink-0" />
//                   <span className="text-xs md:text-sm font-bold">Theory & Practical Combo</span>
//                 </div>
//               </div>
//             </div>

//           </motion.div>
//         </div>
//       </section>

//       {/* FOOTER */}
//       {/* <footer className="py-10 md:py-12 bg-[#2F5D50] text-white text-center px-4">
//         <p className="font-black text-lg md:text-xl mb-1 md:mb-2">The Great Honey Co.</p>
//         <p className="text-[10px] md:text-xs font-bold opacity-50 uppercase tracking-[0.2em]">© {new Date().getFullYear()} Saola Innovations</p>
//       </footer> */}

//       {/* MOBILE FLOATING CTA HELPER - Only visible on small screens when form isn't complete */}
//       <AnimatePresence>
//         {!bookedSlot && currentStep < 4 && (
//           <motion.div 
//             initial={{ y: 100, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             exit={{ y: 100, opacity: 0 }}
//             className="lg:hidden fixed bottom-4 left-4 right-4 z-50 pointer-events-none"
//           >
//             <div className="bg-gray-900/90 backdrop-blur-md p-4 rounded-2xl shadow-2xl border border-gray-700 flex items-center justify-between text-white pointer-events-auto">
//               <div>
//                 <div className="text-[10px] font-black text-orange-400 uppercase tracking-wider">Step {currentStep} of 3</div>
//                 <div className="text-sm font-bold mt-0.5">
//                   {currentStep === 1 ? "Enter your details" : currentStep === 2 ? "Select a date" : "Pick a time slot"}
//                 </div>
//               </div>
//               <button 
//                 onClick={() => document.getElementById('booking-form').scrollIntoView({ behavior: 'smooth' })}
//                 className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center text-white shadow-lg shadow-orange-500/30"
//               >
//                 <ArrowRight size={18} />
//               </button>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//     </div>
//   );
// }
// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { ref, get, push, set, runTransaction, query, orderByChild, equalTo } from "firebase/database";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
// import { database as db } from "../FirebaseConfig";
// import { motion, AnimatePresence } from "framer-motion";
// import toast from "react-hot-toast";
// import { 
//   CheckCircle, Hexagon, Shield, BookOpen, ArrowRight, User, Phone, Leaf, Star, Clock, TestTube, Droplets, X
// } from "lucide-react";

// export default function LearnBK() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const auth = getAuth();
  
//   const [userData, setUserData] = useState({ name: "", mobile: "", type: "", date: "", slot: "" });
//   const [authUser, setAuthUser] = useState(null);
//   const [dates, setDates] = useState([]);
//   const [slots, setSlots] = useState({});
//   const [bookedSlot, setBookedSlot] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   // Animations
//   const fadeInUp = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.5 } } };
//   const staggerContainer = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.1 } } };

//   // Syllabus
//   const syllabus = [
//     { day: 1, dot: "bg-yellow-400", theme: "Introduction to Apiculture", desc: "Apiculture, beekeeper, bee types, equipment, feeding, hive intro." },
//     { day: 2, dot: "bg-green-500", theme: "Hive Life & Wild Honey", desc: "Wild honey hunting, species, hive types, comb observation, bee castes." },
//     { day: 3, dot: "bg-blue-500", theme: "Life Cycles & Queen Management", desc: "Egg stages, lifetimes, timelines, queen introduction, swarming." },
//     { day: 4, dot: "bg-purple-500", theme: "Records, Seasons & Products", desc: "Seasonal maintenance, field setup, aerial survey, honey grades." },
//     { day: 5, dot: "bg-cyan-400", theme: "Business & Sustainability", desc: "Costing, diseases, pricing strategy, government schemes (NABARD, FSSAI)." }
//   ];

//   const scrollingImages = Array.from({ length: 20 }, (_, i) => `/assets/LearnBK/images/${i + 21}.jpg`);

//   // Workshop Pricing Config
//   const workshopConfig = {
//     experiential: { title: "1-Day Experiential", price: 2000, desc: "Hive handling & honey tasting" },
//     "5day": { title: "5-Day Masterclass", price: 12000, desc: "Complete training + Hive Kit" }
//   };

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
//       if (!currentUser) {
//         navigate(`/login?redirect=${location.pathname}`);
//       } else {
//         setAuthUser(currentUser);
//         checkUserAlreadyBooked(currentUser.uid);
//       }
//     });
//     return () => unsubscribe();
//   }, [navigate, location.pathname]);

//   const checkUserAlreadyBooked = async (uid) => {
//     try {
//       const bookingsRef = ref(db, "bookings");
//       const userBookingsQuery = query(bookingsRef, orderByChild("uid"), equalTo(uid));
//       const snapshot = await get(userBookingsQuery);
      
//       if (snapshot.exists()) {
//         const booking = Object.values(snapshot.val())[0];
//         setBookedSlot({ date: booking.date, slotName: booking.slotName, type: booking.type });
//       }
//     } catch (error) {
//       console.error("Error checking bookings", error);
//     }
//   };

//   const fetchDates = async (selectedType) => {
//     setDates([]);
//     setSlots({});
//     try {
//       const snapshot = await get(ref(db, `slots/${selectedType}`));
//       if (snapshot.exists()) {
//         const allDates = snapshot.val();
//         const currentDate = new Date();
//         currentDate.setHours(0, 0, 0, 0);
        
//         const futureDates = Object.keys(allDates).filter(dateString => {
//           const [year, month, day] = dateString.split("-").map(Number);
//           return new Date(year, month - 1, day) >= currentDate;
//         });
        
//         setDates(futureDates.sort((a, b) => new Date(a) - new Date(b)));
//       }
//     } catch (e) { toast.error("Error loading calendar"); }
//   };

//   const fetchSlotsForDate = (date) => {
//     setUserData(prev => ({ ...prev, date, slot: "" }));
//     get(ref(db, `slots/${userData.type}/${date}`)).then(snap => setSlots(snap.val() || {}));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setUserData({ ...userData, [name]: name === "mobile" ? value.replace(/\D/g, "").slice(0, 10) : value });
//   };

//   const handleTypeSelect = (type) => {
//     setUserData(prev => ({ ...prev, type, date: "", slot: "" }));
//     fetchDates(type);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!userData.name || userData.mobile.length < 10 || !userData.date || !userData.slot || !userData.type) {
//       return toast.error("Please complete all steps.");
//     }

//     setIsSubmitting(true);
//     const slotRef = ref(db, `slots/${userData.type}/${userData.date}/${userData.slot}`);
//     const selectedSlotName = slots[userData.slot].name;

//     try {
//       const transactionResult = await runTransaction(slotRef, (currentSlot) => {
//         if (currentSlot && currentSlot.booked < currentSlot.limit) {
//           currentSlot.booked++;
//           return currentSlot;
//         }
//         return; 
//       });

//       if (!transactionResult.committed) {
//         toast.error("Sorry, this slot just filled up! Please pick another.");
//         setIsSubmitting(false);
//         return fetchSlotsForDate(userData.date);
//       }

//       const newBookingRef = push(ref(db, "bookings"));
//       await set(newBookingRef, {
//         uid: authUser.uid,
//         email: authUser.email,
//         name: userData.name,
//         mobile: userData.mobile,
//         type: userData.type,
//         workshopName: workshopConfig[userData.type].title,
//         date: userData.date,
//         slotId: userData.slot,
//         slotName: selectedSlotName,
//         timestamp: Date.now(),
//         status: "CONFIRMED"
//       });

//       toast.success("Registration Successful!");
//       setBookedSlot({ date: userData.date, slotName: selectedSlotName, type: userData.type });
//     } catch (error) {
//       toast.error("Booking failed. Please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const formatDateForUI = (dateString) => {
//     const [year, month, day] = dateString.split("-").map(Number);
//     return new Date(year, month - 1, day).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
//   };

//   if (!authUser) return null;

//   return (
//     <div className="mt-[40px] min-h-screen bg-[#F7F3EB] text-[#4A2511] selection:bg-orange-200 overflow-x-hidden">
      
//       <style dangerouslySetInnerHTML={{__html: `
//         @keyframes scroll { 0% { transform: translateX(0); } 100% { transform: translateX(calc(-250px * 10 - 1.5rem * 10)); } }
//         .animate-scroll { display: flex; width: calc(250px * 20 + 1.5rem * 20); animation: scroll 40s linear infinite; }
//         .animate-scroll:hover { animation-play-state: paused; }
//       `}} />

//       {/* HERO SECTION */}
//       <section className="relative mt-15 h-[85vh] md:h-[90vh] w-full flex items-center justify-center overflow-hidden">
//         <video autoPlay loop muted playsInline className="absolute z-0 w-full h-full object-cover">
//           <source src="/assets/LearnBK/bgVideo.mp4" type="video/mp4" />
//         </video>
//         <div className="absolute z-10 inset-0 bg-gradient-to-b from-black/80 via-black/50 to-transparent" />

//         <div className="relative z-20 text-center px-4 md:px-6 max-w-5xl w-full mt-10">
//           <motion.div initial="hidden" animate="visible" variants={fadeInUp}>
//             <h1 className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white mb-4 sm:mb-6 leading-[1.1] md:leading-[0.9] tracking-tight drop-shadow-lg">
//               MASTER BEEKEEPING <br className="hidden sm:block"/><span className="text-orange-400 text-3xl sm:text-5xl md:text-6xl">FROM HIVE TO HARVEST.</span>
//             </h1>
//             <p className="text-base sm:text-lg md:text-2xl text-white/90 font-medium mb-8 md:mb-10 max-w-2xl mx-auto drop-shadow-md px-2">
//               Choose between our 1-Day Experiential or the intensive 5-Day Masterclass.
//             </p>
//             <button 
//               onClick={() => setIsModalOpen(true)}
//               className="w-[90%] sm:w-auto bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 md:px-10 md:py-5 rounded-full font-black text-lg md:text-xl shadow-2xl flex items-center justify-center gap-3 mx-auto transition-transform hover:scale-105"
//             >
//               Apply Now <ArrowRight size={24} />
//             </button>
//           </motion.div>
//         </div>
//       </section>

//       {/* MARQUEE */}
     

//       {/* WHY WE STARTED */}
//       <section className="py-16 md:py-24 px-4 sm:px-6 max-w-7xl mx-auto border-b border-orange-200/50">
//         <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} variants={staggerContainer} className="grid lg:grid-cols-2 gap-10 md:gap-16 items-center">
//           <motion.div variants={fadeInUp} className="space-y-4 md:space-y-6">
//             <div className="w-12 h-12 md:w-16 md:h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-4 md:mb-6"><Leaf className="text-orange-600 w-6 h-6 md:w-8 md:h-8" /></div>
//             <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 leading-tight">Why We Started This</h2>
//             <p className="text-base md:text-lg font-medium text-gray-600 leading-relaxed">We started this initiative after realising that many farmers lacked access to proper, structured training. Most were left to learn through trial and error.</p>
//             <p className="text-base md:text-lg font-medium text-gray-600 leading-relaxed">This program bridges that gap through practical, hands-on training, helping farmers earn from honey and improve crop yields through cross-pollination.</p>
//           </motion.div>
//           <motion.div variants={fadeInUp} className="space-y-6 bg-white p-6 md:p-10 rounded-[24px] md:rounded-[40px] shadow-xl border border-orange-100">
//             <h3 className="text-xl md:text-2xl font-black flex items-center gap-3"><Star className="text-orange-500 shrink-0" /> What You’ll Gain 🐝</h3>
//             <ul className="space-y-3 md:space-y-4">
//               {["Hands-on experience working with live hives", "Confidence to handle bees safely", "Guidance to start your own apiary", "Skills in honey extraction", "Sustainable income knowledge"].map((item, i) => (
//                 <li key={i} className="flex items-start gap-3 md:gap-4"><CheckCircle className="text-green-500 w-5 h-5 md:w-6 md:h-6 shrink-0 mt-0.5" /><span className="font-bold text-sm md:text-base text-gray-700">{item}</span></li>
//               ))}
//             </ul>
//           </motion.div>
//         </motion.div>
//       </section>

//  <section className="py-12 bg-white border-b border-orange-100 overflow-hidden relative">
//         <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
//         <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>
//         <div className="animate-scroll gap-6 px-6">
//           {scrollingImages.map((src, idx) => (
//             <div key={idx} className="w-[250px] h-[200px] md:h-[250px] shrink-0 rounded-3xl overflow-hidden shadow-sm border border-gray-100">
//               <img src={src} alt={`Beekeeping ${idx}`} className="w-full h-full object-cover hover:scale-110 transition-transform duration-700" />
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* HOW IT WORKS */}
//       <section className="py-16 md:py-24 px-4 sm:px-6 max-w-7xl mx-auto border-b border-orange-200/50">
//          <div className="text-center mb-10 md:mb-16">
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-3 md:mb-4">How The Program Works</h2>
//           <p className="font-bold text-sm md:text-base text-gray-500 px-4">A perfect balance of science and hands-on practice.</p>
//         </div>
//         <div className="grid lg:grid-cols-2 gap-8 md:gap-12">
//           <div className="flex flex-col justify-center space-y-6">
//             <div className="bg-white p-6 md:p-8 rounded-[32px] shadow-sm border border-orange-100 flex gap-6 items-start">
//               <div className="w-14 h-14 shrink-0 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center"><BookOpen className="w-7 h-7" /></div>
//               <div><h4 className="text-xl font-black mb-2">Theory</h4><p className="text-gray-600 font-medium">Deep dive into bee biology and the science behind honey production.</p></div>
//             </div>
//             <div className="bg-white p-6 md:p-8 rounded-[32px] shadow-sm border border-orange-100 flex gap-6 items-start">
//               <div className="w-14 h-14 shrink-0 bg-orange-100 text-orange-600 rounded-2xl flex items-center justify-center"><Hexagon className="w-7 h-7" /></div>
//               <div><h4 className="text-xl font-black mb-2">Hands-On</h4><p className="text-gray-600 font-medium">Suit up for live hive handling, frame inspection, and honey extraction.</p></div>
//             </div>
//           </div>
//           <div className="bg-gray-900 text-white p-8 md:p-12 rounded-[40px] shadow-2xl relative overflow-hidden">
//             <div className="absolute -right-10 -top-10 text-white/5"><Clock size={200} /></div>
//             <h3 className="text-2xl md:text-3xl font-black mb-8 relative z-10 text-orange-400">1-Day Experiential Flow</h3>
//             <div className="space-y-8 relative z-10">
//               <div className="flex gap-4 items-start"><div className="w-16 shrink-0 font-black text-xl text-orange-500">1 hr</div><div><h5 className="font-bold text-lg mb-1">Pollination & Anatomy</h5><p className="text-gray-400 text-sm">Types of bees, understanding nectar to honey conversion.</p></div></div>
//               <div className="w-full h-px bg-gray-800"></div>
//               <div className="flex gap-4 items-start"><div className="w-16 shrink-0 font-black text-xl text-orange-500">½ hr</div><div><h5 className="font-bold text-lg mb-1 flex items-center gap-2">Extraction <Droplets size={16} className="text-yellow-400"/></h5><p className="text-gray-400 text-sm">Practical demonstration safely extracting honey.</p></div></div>
//               <div className="w-full h-px bg-gray-800"></div>
//               <div className="flex gap-4 items-start"><div className="w-16 shrink-0 font-black text-xl text-orange-500">½ hr</div><div><h5 className="font-bold text-lg mb-1 flex items-center gap-2">Tasting <TestTube size={16} className="text-green-400"/></h5><p className="text-gray-400 text-sm">Taste fresh, raw honey directly from the comb.</p></div></div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* SYLLABUS */}
//       <section className="py-16 md:py-24 px-4 sm:px-6 max-w-7xl mx-auto border-b border-orange-200/50">
//         <div className="text-center mb-10 md:mb-16">
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-3 md:mb-4">5-Day Workshop Plan</h2>
//           <p className="font-bold text-sm md:text-base text-gray-500 px-4">Comprehensive daily breakdown of your learning journey.</p>
//         </div>
//         <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} variants={staggerContainer} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-6">
//           {syllabus.map((item) => (
//             <motion.div key={item.day} variants={fadeInUp} className="group bg-white p-6 md:p-8 rounded-[24px] shadow-sm hover:shadow-xl transition-all border border-orange-100 relative">
//               <div className={`absolute top-6 right-6 w-4 h-4 rounded-full ${item.dot} shadow-sm`}></div>
//               <div className="text-sm font-black text-gray-400 uppercase tracking-widest mb-4">Day {item.day}</div>
//               <h4 className="text-lg font-black mb-3">{item.theme}</h4>
//               <p className="text-sm font-medium text-gray-500">{item.desc}</p>
//             </motion.div>
//           ))}
//         </motion.div>
//       </section>

//       {/* FINAL BOTTOM CTA */}
//       <section className="py-20 md:py-32 px-4 sm:px-6 max-w-4xl mx-auto text-center">
//         <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6">Ready to get sticky and save the bees?</h2>
//         <p className="text-lg text-gray-600 mb-10 font-medium">Join our upcoming batches and start your beekeeping journey today.</p>
//         <button 
//           onClick={() => setIsModalOpen(true)}
//           className="w-[90%] sm:w-auto bg-orange-500 hover:bg-orange-600 text-white px-10 py-5 rounded-full font-black text-xl shadow-2xl flex items-center justify-center gap-3 mx-auto transition-transform hover:scale-105"
//         >
//           Apply Now <ArrowRight size={24} />
//         </button>
//       </section>

//       {/* POPUP MODAL FOR BOOKING */}
//       <AnimatePresence>
//         {isModalOpen && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-md">
//             <motion.div 
//               initial={{ opacity: 0, scale: 0.95, y: 20 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.95, y: 20 }}
//               className="bg-white w-full max-w-5xl rounded-[32px] overflow-hidden shadow-2xl flex flex-col lg:flex-row relative max-h-[90vh] overflow-y-auto hide-scrollbar"
//             >
//               <button onClick={() => setIsModalOpen(false)} className="absolute top-4 right-4 z-50 p-2 bg-gray-100 hover:bg-gray-200 rounded-full transition text-gray-600">
//                 <X size={20} />
//               </button>

//               {/* Form Side */}
//               <div className="w-full lg:w-3/5 p-6 sm:p-8 md:p-12">
//                 <h2 className="text-3xl font-black mb-6 text-[#4A2511]">Book Your Spot</h2>

//                 {bookedSlot ? (
//                   <div className="py-10 text-center">
//                     <CheckCircle className="text-green-500 mx-auto mb-4 w-16 h-16" />
//                     <h3 className="text-2xl font-black text-[#4A2511]">Registration Confirmed!</h3>
//                     <p className="font-bold text-orange-900/70 mt-4">
//                       You are scheduled for the <strong>{workshopConfig[bookedSlot.type].title}</strong> on <br />
//                       <span className="text-orange-600">{formatDateForUI(bookedSlot.date)}</span> ({bookedSlot.slotName}).
//                     </p>
//                     <button onClick={() => setIsModalOpen(false)} className="mt-8 px-8 py-3 bg-[#4A2511] text-white rounded-xl font-bold">Done</button>
//                   </div>
//                 ) : (
//                   <form onSubmit={handleSubmit} className="space-y-8">
                    
//                     {/* Step 1: Select Workshop */}
//                     <div className="space-y-3">
//                       <p className="text-xs font-black uppercase tracking-widest text-orange-600 flex items-center gap-2"><span className="bg-orange-100 px-2 py-0.5 rounded">1</span> Select Workshop</p>
//                       <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                         {Object.entries(workshopConfig).map(([key, config]) => (
//                           <button 
//                             key={key} type="button" onClick={() => handleTypeSelect(key)}
//                             className={`p-4 rounded-2xl border-2 text-left transition-all ${userData.type === key ? "bg-orange-50 border-orange-500 shadow-md" : "border-gray-200 bg-white hover:border-orange-300"}`}
//                           >
//                             <h4 className={`font-black ${userData.type === key ? "text-orange-700" : "text-gray-800"}`}>{config.title}</h4>
//                             <p className="text-xs text-gray-500 mt-1">{config.desc}</p>
//                             <div className="mt-2 text-sm font-bold text-[#4A2511]">₹{config.price.toLocaleString()}</div>
//                           </button>
//                         ))}
//                       </div>
//                     </div>

//                     <AnimatePresence>
//                       {userData.type && (
//                         <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} className="space-y-8 overflow-hidden">
                          
//                           {/* Step 2: Details */}
//                           <div className="space-y-3 mt-4">
//                             <p className="text-xs font-black uppercase tracking-widest text-orange-600 flex items-center gap-2"><span className="bg-orange-100 px-2 py-0.5 rounded">2</span> Your Details</p>
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                               <div className="relative"><User className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-900/40 w-5 h-5" /><input type="text" name="name" placeholder="Full Name" required value={userData.name} onChange={handleChange} className="w-full pl-11 pr-4 py-3 rounded-xl bg-[#F7F3EB] border-2 border-transparent focus:border-orange-500 font-bold outline-none text-[#4A2511] placeholder-orange-900/40" /></div>
//                               <div className="relative"><Phone className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-900/40 w-5 h-5" /><input type="tel" name="mobile" placeholder="WhatsApp Number" required value={userData.mobile} onChange={handleChange} className="w-full pl-11 pr-4 py-3 rounded-xl bg-[#F7F3EB] border-2 border-transparent focus:border-orange-500 font-bold outline-none text-[#4A2511] placeholder-orange-900/40" /></div>
//                             </div>
//                           </div>

//                           {/* Step 3: Dates */}
//                           <div className="space-y-3">
//                             <p className="text-xs font-black uppercase tracking-widest text-orange-600 flex items-center gap-2"><span className="bg-orange-100 px-2 py-0.5 rounded">3</span> Select Date</p>
//                             {dates.length === 0 ? <p className="text-sm font-bold text-gray-500">No dates available currently.</p> : (
//                               <div className="flex flex-wrap gap-2">
//                                 {dates.map(d => (
//                                   <button key={d} type="button" onClick={() => fetchSlotsForDate(d)} className={`px-4 py-2 rounded-xl text-sm font-black transition-all ${userData.date === d ? "bg-orange-500 text-white shadow-md" : "bg-orange-50 text-orange-900 border border-orange-200/50 hover:bg-orange-100"}`}>{formatDateForUI(d)}</button>
//                                 ))}
//                               </div>
//                             )}
//                           </div>

//                           {/* Step 4: Slots */}
//                           {userData.date && (
//                             <div className="space-y-3">
//                               <p className="text-xs font-black uppercase tracking-widest text-orange-600 flex items-center gap-2"><span className="bg-orange-100 px-2 py-0.5 rounded">4</span> Pick a Session</p>
//                               <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//                                 {Object.entries(slots).map(([key, s]) => {
//                                   const isFull = s.booked >= s.limit;
//                                   return (
//                                     <button key={key} type="button" disabled={isFull} onClick={() => setUserData({...userData, slot: key})} className={`p-4 rounded-xl border-2 text-left transition-all ${isFull ? "opacity-50 bg-[#F7F3EB] cursor-not-allowed border-transparent" : userData.slot === key ? "bg-[#4A2511] border-[#4A2511] text-white shadow-md" : "border-orange-200 bg-white hover:border-orange-400"}`}>
//                                       <div className="font-black text-sm">{s.name}</div>
//                                       <div className={`text-[10px] font-bold uppercase mt-1 ${isFull ? "text-red-500" : userData.slot === key ? "text-orange-200" : "text-orange-900/60"}`}>{isFull ? "Full" : `${s.limit - s.booked} spots left`}</div>
//                                     </button>
//                                   )
//                                 })}
//                               </div>
//                             </div>
//                           )}

//                           <button disabled={isSubmitting || !userData.slot} type="submit" className="w-full mt-4 py-4 bg-orange-500 hover:bg-orange-600 disabled:bg-gray-300 text-white rounded-xl font-black text-lg shadow-xl shadow-orange-500/20 transition-all">
//                             {isSubmitting ? "Confirming..." : "Confirm & Pay"}
//                           </button>
//                         </motion.div>
//                       )}
//                     </AnimatePresence>
//                   </form>
//                 )}
//               </div>

//               {/* DYNAMIC SIDEBAR PRICING */}
//               <div className="w-full lg:w-2/5 bg-[#4A2511] p-8 sm:p-12 text-[#F7F3EB] flex flex-col justify-between">
//                 <div>
//                   <h4 className="text-orange-400 font-black text-sm uppercase tracking-widest mb-8">Summary</h4>
//                   <div className="space-y-6">
//                     {!userData.type && (
//                       <div className="text-orange-900/60 text-sm italic">Select a workshop to view pricing.</div>
//                     )}
                    
//                     {userData.type === 'experiential' && (
//                       <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
//                         <div className="flex justify-between items-start border-b border-orange-900/50 pb-4">
//                           <div>
//                             <span className="block font-bold opacity-80">{workshopConfig.experiential.title}</span>
//                             <span className="text-xs opacity-60">Workshop Fee</span>
//                           </div>
//                           <span className="text-xl font-black">₹{workshopConfig.experiential.price.toLocaleString()}</span>
//                         </div>
//                         <div className="flex justify-between items-end pt-4">
//                           <span className="font-black text-orange-400 text-lg">Total</span>
//                           <span className="text-4xl font-black text-white">₹{workshopConfig.experiential.price.toLocaleString()}</span>
//                         </div>
//                       </motion.div>
//                     )}

//                     {userData.type === '5day' && (
//                       <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
//                         <div className="flex justify-between items-start border-b border-orange-900/50 pb-4">
//                           <div>
//                             <span className="block font-bold opacity-80">{workshopConfig["5day"].title}</span>
//                             <span className="text-xs opacity-60">Workshop Classes</span>
//                           </div>
//                           <span className="text-xl font-black">₹7,000</span>
//                         </div>
//                         <div className="flex justify-between items-center border-b border-orange-900/50 py-4">
//                           <div>
//                             <span className="block font-bold opacity-80">Add-on Hive Kit</span>
//                             <span className="text-xs opacity-60 line-through">₹7,500</span>
//                           </div>
//                           <span className="text-xl font-black text-orange-400">₹5,000</span>
//                         </div>
//                         <div className="flex justify-between items-end pt-4">
//                           <span className="font-black text-orange-400 text-lg">Total Overall</span>
//                           <span className="text-4xl font-black text-white">₹12,000</span>
//                         </div>
//                       </motion.div>
//                     )}
//                   </div>
//                 </div>
                
//                 <div className="space-y-4 mt-12">
//                   <div className="flex items-center gap-4 bg-white/5 p-4 rounded-2xl border border-white/10"><Shield className="text-orange-400 w-5 h-5 shrink-0" /><span className="text-sm font-bold">Safety Gear Provided</span></div>
//                   <div className="flex items-center gap-4 bg-white/5 p-4 rounded-2xl border border-white/10"><BookOpen className="text-orange-400 w-5 h-5 shrink-0" /><span className="text-sm font-bold">Expert Instructors</span></div>
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// }


import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ref, get, push, set, runTransaction, query, orderByChild, equalTo } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { database as db } from "../FirebaseConfig";
import { motion, AnimatePresence } from "framer-motion";
import toast from "react-hot-toast";
import { 
  CheckCircle, Hexagon, Shield, BookOpen, ArrowRight, User, Phone, Leaf, Star, Clock, TestTube, Droplets, X
} from "lucide-react";

export default function LearnBK() {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();
  
  const [userData, setUserData] = useState({ name: "", mobile: "", type: "", date: "", slot: "" });
  const [authUser, setAuthUser] = useState(null);
  const [dates, setDates] = useState([]);
  const [slots, setSlots] = useState({});
  const [bookedSlot, setBookedSlot] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Animations
  const fadeInUp = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.5 } } };
  const staggerContainer = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.1 } } };

  // Syllabus
  const syllabus = [
    { day: 1, dot: "bg-yellow-400", theme: "Introduction to Apiculture", desc: "Apiculture, beekeeper, bee types, equipment, feeding, hive intro." },
    { day: 2, dot: "bg-green-500", theme: "Hive Life & Wild Honey", desc: "Wild honey hunting, species, hive types, comb observation, bee castes." },
    { day: 3, dot: "bg-blue-500", theme: "Life Cycles & Queen Management", desc: "Egg stages, lifetimes, timelines, queen introduction, swarming." },
    { day: 4, dot: "bg-purple-500", theme: "Records, Seasons & Products", desc: "Seasonal maintenance, field setup, aerial survey, honey grades." },
    { day: 5, dot: "bg-cyan-400", theme: "Business & Sustainability", desc: "Costing, diseases, pricing strategy, government schemes (NABARD, FSSAI)." }
  ];

  const scrollingImages = Array.from({ length: 20 }, (_, i) => `/assets/LearnBK/images/${i + 21}.jpg`);

  // Workshop Pricing Config
  const workshopConfig = {
    experiential: { title: "1-Day Experiential", price: 2000, desc: "Hive handling & honey tasting" },
    "5day": { title: "5-Day Masterclass", price: 12000, desc: "Complete training + Hive Kit" }
  };

  // 1. Auth Listener (No longer forcing redirect immediately)
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setAuthUser(currentUser);
        checkUserAlreadyBooked(currentUser.uid);
      } else {
        setAuthUser(null);
      }
    });
    return () => unsubscribe();
  }, [auth]);

  // 2. Draft Restoration (Runs once on mount)
  useEffect(() => {
    const restoreDraft = async () => {
      const savedDraft = sessionStorage.getItem("learnBkDraft");
      if (savedDraft) {
        const { savedUser, modalOpen } = JSON.parse(savedDraft);
        
        // Pre-fetch dates and slots to rebuild UI state seamlessly
        if (savedUser.type) {
          try {
            const snapshot = await get(ref(db, `slots/${savedUser.type}`));
            if (snapshot.exists()) {
              const allDates = snapshot.val();
              const currentDate = new Date();
              currentDate.setHours(0, 0, 0, 0);
              
              const futureDates = Object.keys(allDates).filter(dateString => {
                const [year, month, day] = dateString.split("-").map(Number);
                return new Date(year, month - 1, day) >= currentDate;
              });
              setDates(futureDates.sort((a, b) => new Date(a) - new Date(b)));
            }
          } catch (e) { console.error("Error restoring dates", e); }
        }

        if (savedUser.date && savedUser.type) {
          try {
            const snap = await get(ref(db, `slots/${savedUser.type}/${savedUser.date}`));
            setSlots(snap.val() || {});
          } catch (e) { console.error("Error restoring slots", e); }
        }

        setUserData(savedUser);
        setIsModalOpen(modalOpen);
        sessionStorage.removeItem("learnBkDraft"); // Clear draft after loading
      }
    };
    
    restoreDraft();
  }, []);

  const checkUserAlreadyBooked = async (uid) => {
    try {
      const bookingsRef = ref(db, "bookings");
      const userBookingsQuery = query(bookingsRef, orderByChild("uid"), equalTo(uid));
      const snapshot = await get(userBookingsQuery);
      
      if (snapshot.exists()) {
        const booking = Object.values(snapshot.val())[0];
        setBookedSlot({ date: booking.date, slotName: booking.slotName, type: booking.type });
      }
    } catch (error) {
      console.error("Error checking bookings", error);
    }
  };

  const fetchDates = async (selectedType) => {
    setDates([]);
    setSlots({});
    try {
      const snapshot = await get(ref(db, `slots/${selectedType}`));
      if (snapshot.exists()) {
        const allDates = snapshot.val();
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        
        const futureDates = Object.keys(allDates).filter(dateString => {
          const [year, month, day] = dateString.split("-").map(Number);
          return new Date(year, month - 1, day) >= currentDate;
        });
        
        setDates(futureDates.sort((a, b) => new Date(a) - new Date(b)));
      }
    } catch (e) { toast.error("Error loading calendar"); }
  };

  const fetchSlotsForDate = (date) => {
    setUserData(prev => ({ ...prev, date, slot: "" }));
    get(ref(db, `slots/${userData.type}/${date}`)).then(snap => setSlots(snap.val() || {}));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: name === "mobile" ? value.replace(/\D/g, "").slice(0, 10) : value });
  };

  const handleTypeSelect = (type) => {
    setUserData(prev => ({ ...prev, type, date: "", slot: "" }));
    fetchDates(type);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userData.name || userData.mobile.length < 10 || !userData.date || !userData.slot || !userData.type) {
      return toast.error("Please complete all steps.");
    }

    // Intercept if not logged in -> save state -> redirect
    if (!authUser) {
      sessionStorage.setItem("learnBkDraft", JSON.stringify({ savedUser: userData, modalOpen: true }));
      toast.success("Please login to finalize your booking.");
      return navigate(`/login?redirect=${location.pathname}`);
    }

    setIsSubmitting(true);
    const slotRef = ref(db, `slots/${userData.type}/${userData.date}/${userData.slot}`);
    const selectedSlotName = slots[userData.slot].name;

    try {
      const transactionResult = await runTransaction(slotRef, (currentSlot) => {
        // Handle the Firebase local cache miss (forces it to ask the server)
        if (currentSlot === null) {
          return { booked: 0, limit: 999, name: "Loading..." }; 
        }

        // The actual logic once the server data is loaded
        if (currentSlot.booked < currentSlot.limit) {
          currentSlot.booked += 1;
          return currentSlot;
        }

        // Abort only if we are absolutely sure the limit is reached
        return; 
      });
      
      if (!transactionResult.committed) {
        toast.error("Sorry, this slot just filled up! Please pick another.");
        setIsSubmitting(false);
        return fetchSlotsForDate(userData.date);
      }

      const workshopTitle = workshopConfig[userData.type].title;
      const newBookingRef = push(ref(db, "bookings"));
      
      await set(newBookingRef, {
        uid: authUser.uid,
        email: authUser.email,
        name: userData.name,
        mobile: userData.mobile,
        type: userData.type,
        workshopName: workshopTitle,
        date: userData.date,
        slotId: userData.slot,
        slotName: selectedSlotName,
        timestamp: Date.now(),
        status: "CONFIRMED"
      });

      toast.success("Registration Successful! Redirecting to WhatsApp...");
      setBookedSlot({ date: userData.date, slotName: selectedSlotName, type: userData.type });

      // --- NEW WHATSAPP REDIRECT LOGIC ---
      const formattedDate = formatDateForUI(userData.date);
      
      // Construct the message text
      const whatsappMessage = `Hello The Great Honey Co., I have successfully registered for a Beekeeping Workshop! 🐝\n\n*Booking Details:*\n👤 Name: ${userData.name}\n📱 Mobile: ${userData.mobile}\n🍯 Workshop: ${workshopTitle}\n📅 Date: ${formattedDate}\n⏰ Slot: ${selectedSlotName}\n\nPlease confirm my booking.`;
      
      // Create the WhatsApp URL (Encode the text to handle spaces and special characters)
      const whatsappUrl = `https://wa.me/918639542319?text=${encodeURIComponent(whatsappMessage)}`;
      
      // Open WhatsApp in a new tab
      window.open(whatsappUrl, '_blank');
      // -----------------------------------

    } catch (error) {
      toast.error("Booking failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!userData.name || userData.mobile.length < 10 || !userData.date || !userData.slot || !userData.type) {
  //     return toast.error("Please complete all steps.");
  //   }

  //   // 3. Intercept if not logged in -> save state -> redirect
  //   if (!authUser) {
  //     sessionStorage.setItem("learnBkDraft", JSON.stringify({ savedUser: userData, modalOpen: true }));
  //     toast.success("Please login to finalize your booking.");
  //     return navigate(`/login?redirect=${location.pathname}`);
  //   }

  //   setIsSubmitting(true);
  //   const slotRef = ref(db, `slots/${userData.type}/${userData.date}/${userData.slot}`);
  //   const selectedSlotName = slots[userData.slot].name;

  //   try {
  //     // const transactionResult = await runTransaction(slotRef, (currentSlot) => {
  //     //   if (currentSlot && currentSlot.booked < currentSlot.limit) {
  //     //     currentSlot.booked++;
  //     //     return currentSlot;
  //     //   }
  //     //   return; 
  //     // });

  //     const transactionResult = await runTransaction(slotRef, (currentSlot) => {
  //       // 1. Handle the Firebase local cache miss (forces it to ask the server)
  //       if (currentSlot === null) {
  //         return { booked: 0, limit: 999, name: "Loading..." }; 
  //       }

  //       // 2. The actual logic once the server data is loaded
  //       if (currentSlot.booked < currentSlot.limit) {
  //         currentSlot.booked += 1;
  //         return currentSlot;
  //       }

  //       // 3. Abort only if we are absolutely sure the limit is reached
  //       return; 
  //     });
      
  //     if (!transactionResult.committed) {
  //       toast.error("Sorry, this slot just filled up! Please pick another.");
  //       setIsSubmitting(false);
  //       return fetchSlotsForDate(userData.date);
  //     }

  //     const newBookingRef = push(ref(db, "bookings"));
  //     await set(newBookingRef, {
  //       uid: authUser.uid,
  //       email: authUser.email,
  //       name: userData.name,
  //       mobile: userData.mobile,
  //       type: userData.type,
  //       workshopName: workshopConfig[userData.type].title,
  //       date: userData.date,
  //       slotId: userData.slot,
  //       slotName: selectedSlotName,
  //       timestamp: Date.now(),
  //       status: "CONFIRMED"
  //     });

  //     toast.success("Registration Successful!");
  //     setBookedSlot({ date: userData.date, slotName: selectedSlotName, type: userData.type });
  //   } catch (error) {
  //     toast.error("Booking failed. Please try again.");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const formatDateForUI = (dateString) => {
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);

    // If the user has successfully booked a slot, trigger the WhatsApp redirect
    if (bookedSlot) {
      const workshopTitle = workshopConfig[bookedSlot.type].title;
      const formattedDate = formatDateForUI(bookedSlot.date);
      
      const whatsappMessage = `Hello The Great Honey Co., I have successfully registered for a Beekeeping Workshop! 🐝\n\n*Booking Details:*\n👤 Name: ${userData.name}\n📱 Mobile: ${userData.mobile}\n🍯 Workshop: ${workshopTitle}\n📅 Date: ${formattedDate}\n⏰ Slot: ${bookedSlot.slotName}\n\nPlease confirm my booking.`;
      
      const whatsappUrl = `https://wa.me/918639542319?text=${encodeURIComponent(whatsappMessage)}`;
      
      window.open(whatsappUrl, '_blank');
      
      // Optional: Clear the form/booking state if you want them to start fresh next time they open the modal
      // setBookedSlot(null);
      // setUserData({ name: "", mobile: "", type: "", date: "", slot: "" });
    }
  };
  

  // Removed `if (!authUser) return null;` so public users can view the page

  return (
    <div className="mt-[40px] min-h-screen bg-[#F7F3EB] text-[#4A2511] selection:bg-orange-200 overflow-x-hidden">
      
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes scroll { 0% { transform: translateX(0); } 100% { transform: translateX(calc(-250px * 10 - 1.5rem * 10)); } }
        .animate-scroll { display: flex; width: calc(250px * 20 + 1.5rem * 20); animation: scroll 40s linear infinite; }
        .animate-scroll:hover { animation-play-state: paused; }
      `}} />

      {/* HERO SECTION */}
      <section className="relative mt-15 h-[85vh] md:h-[90vh] w-full flex items-center justify-center overflow-hidden">
        <video autoPlay loop muted playsInline className="absolute z-0 w-full h-full object-cover">
          <source src="/assets/LearnBK/bgVideo.mp4" type="video/mp4" />
        </video>
        <div className="absolute z-10 inset-0 bg-gradient-to-b from-black/80 via-black/50 to-transparent" />

        <div className="relative z-20 text-center px-4 md:px-6 max-w-5xl w-full mt-10">
          <motion.div initial="hidden" animate="visible" variants={fadeInUp}>
            <h1 className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white mb-4 sm:mb-6 leading-[1.1] md:leading-[0.9] tracking-tight drop-shadow-lg">
              MASTER BEEKEEPING <br className="hidden sm:block"/><span className="text-orange-400 text-3xl sm:text-5xl md:text-6xl">FROM HIVE TO HARVEST.</span>
            </h1>
            <p className="text-base sm:text-lg md:text-2xl text-white/90 font-medium mb-8 md:mb-10 max-w-2xl mx-auto drop-shadow-md px-2">
              Choose between our 1-Day Experiential or the intensive 5-Day Masterclass.
            </p>
            <button 
              onClick={() => setIsModalOpen(true)}
              className="w-[90%] sm:w-auto bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 md:px-10 md:py-5 rounded-full font-black text-lg md:text-xl shadow-2xl flex items-center justify-center gap-3 mx-auto transition-transform hover:scale-105"
            >
              Apply Now <ArrowRight size={24} />
            </button>
          </motion.div>
        </div>
      </section>

      {/* WHY WE STARTED */}
      <section className="py-16 md:py-24 px-4 sm:px-6 max-w-7xl mx-auto border-b border-orange-200/50">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} variants={staggerContainer} className="grid lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <motion.div variants={fadeInUp} className="space-y-4 md:space-y-6">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-4 md:mb-6"><Leaf className="text-orange-600 w-6 h-6 md:w-8 md:h-8" /></div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 leading-tight">Why We Started This</h2>
            <p className="text-base md:text-lg font-medium text-gray-600 leading-relaxed">We started this initiative after realising that many farmers lacked access to proper, structured training. Most were left to learn through trial and error.</p>
            <p className="text-base md:text-lg font-medium text-gray-600 leading-relaxed">This program bridges that gap through practical, hands-on training, helping farmers earn from honey and improve crop yields through cross-pollination.</p>
          </motion.div>
          <motion.div variants={fadeInUp} className="space-y-6 bg-white p-6 md:p-10 rounded-[24px] md:rounded-[40px] shadow-xl border border-orange-100">
            <h3 className="text-xl md:text-2xl font-black flex items-center gap-3"><Star className="text-orange-500 shrink-0" /> What You’ll Gain 🐝</h3>
            <ul className="space-y-3 md:space-y-4">
              {["Hands-on experience working with live hives", "Confidence to handle bees safely", "Guidance to start your own apiary", "Skills in honey extraction", "Sustainable income knowledge"].map((item, i) => (
                <li key={i} className="flex items-start gap-3 md:gap-4"><CheckCircle className="text-green-500 w-5 h-5 md:w-6 md:h-6 shrink-0 mt-0.5" /><span className="font-bold text-sm md:text-base text-gray-700">{item}</span></li>
              ))}
            </ul>
          </motion.div>
        </motion.div>
      </section>

      <section className="py-12 bg-white border-b border-orange-100 overflow-hidden relative">
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>
        <div className="animate-scroll gap-6 px-6">
          {scrollingImages.map((src, idx) => (
            <div key={idx} className="w-[250px] h-[200px] md:h-[250px] shrink-0 rounded-3xl overflow-hidden shadow-sm border border-gray-100">
              <img src={src} alt={`Beekeeping ${idx}`} className="w-full h-full object-cover hover:scale-110 transition-transform duration-700" />
            </div>
          ))}
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-16 md:py-24 px-4 sm:px-6 max-w-7xl mx-auto border-b border-orange-200/50">
         <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-3 md:mb-4">How The Program Works</h2>
          <p className="font-bold text-sm md:text-base text-gray-500 px-4">A perfect balance of science and hands-on practice.</p>
        </div>
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12">
          <div className="flex flex-col justify-center space-y-6">
            <div className="bg-white p-6 md:p-8 rounded-[32px] shadow-sm border border-orange-100 flex gap-6 items-start">
              <div className="w-14 h-14 shrink-0 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center"><BookOpen className="w-7 h-7" /></div>
              <div><h4 className="text-xl font-black mb-2">Theory</h4><p className="text-gray-600 font-medium">Deep dive into bee biology and the science behind honey production.</p></div>
            </div>
            <div className="bg-white p-6 md:p-8 rounded-[32px] shadow-sm border border-orange-100 flex gap-6 items-start">
              <div className="w-14 h-14 shrink-0 bg-orange-100 text-orange-600 rounded-2xl flex items-center justify-center"><Hexagon className="w-7 h-7" /></div>
              <div><h4 className="text-xl font-black mb-2">Hands-On</h4><p className="text-gray-600 font-medium">Suit up for live hive handling, frame inspection, and honey extraction.</p></div>
            </div>
          </div>
          <div className="bg-gray-900 text-white p-8 md:p-12 rounded-[40px] shadow-2xl relative overflow-hidden">
            <div className="absolute -right-10 -top-10 text-white/5"><Clock size={200} /></div>
            <h3 className="text-2xl md:text-3xl font-black mb-8 relative z-10 text-orange-400">1-Day Experiential Flow</h3>
            <div className="space-y-8 relative z-10">
              <div className="flex gap-4 items-start"><div className="w-16 shrink-0 font-black text-xl text-orange-500">1 hr</div><div><h5 className="font-bold text-lg mb-1">Pollination & Anatomy</h5><p className="text-gray-400 text-sm">Types of bees, understanding nectar to honey conversion.</p></div></div>
              <div className="w-full h-px bg-gray-800"></div>
              <div className="flex gap-4 items-start"><div className="w-16 shrink-0 font-black text-xl text-orange-500">½ hr</div><div><h5 className="font-bold text-lg mb-1 flex items-center gap-2">Extraction <Droplets size={16} className="text-yellow-400"/></h5><p className="text-gray-400 text-sm">Practical demonstration safely extracting honey.</p></div></div>
              <div className="w-full h-px bg-gray-800"></div>
              <div className="flex gap-4 items-start"><div className="w-16 shrink-0 font-black text-xl text-orange-500">½ hr</div><div><h5 className="font-bold text-lg mb-1 flex items-center gap-2">Tasting <TestTube size={16} className="text-green-400"/></h5><p className="text-gray-400 text-sm">Taste fresh, raw honey directly from the comb.</p></div></div>
            </div>
          </div>
        </div>
      </section>

      {/* SYLLABUS */}
      <section className="py-16 md:py-24 px-4 sm:px-6 max-w-7xl mx-auto border-b border-orange-200/50">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-3 md:mb-4">5-Day Workshop Plan</h2>
          <p className="font-bold text-sm md:text-base text-gray-500 px-4">Comprehensive daily breakdown of your learning journey.</p>
        </div>
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} variants={staggerContainer} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-6">
          {syllabus.map((item) => (
            <motion.div key={item.day} variants={fadeInUp} className="group bg-white p-6 md:p-8 rounded-[24px] shadow-sm hover:shadow-xl transition-all border border-orange-100 relative">
              <div className={`absolute top-6 right-6 w-4 h-4 rounded-full ${item.dot} shadow-sm`}></div>
              <div className="text-sm font-black text-gray-400 uppercase tracking-widest mb-4">Day {item.day}</div>
              <h4 className="text-lg font-black mb-3">{item.theme}</h4>
              <p className="text-sm font-medium text-gray-500">{item.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </section>

      {/* FINAL BOTTOM CTA */}
      <section className="py-20 md:py-32 px-4 sm:px-6 max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6">Ready to get sticky and save the bees?</h2>
        <p className="text-lg text-gray-600 mb-10 font-medium">Join our upcoming batches and start your beekeeping journey today.</p>
        <button 
          onClick={() => setIsModalOpen(true)}
          className="w-[90%] sm:w-auto bg-orange-500 hover:bg-orange-600 text-white px-10 py-5 rounded-full font-black text-xl shadow-2xl flex items-center justify-center gap-3 mx-auto transition-transform hover:scale-105"
        >
          Apply Now <ArrowRight size={24} />
        </button>
      </section>

      {/* POPUP MODAL FOR BOOKING */}
      <AnimatePresence>
        {isModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-md">
            <motion.div 
              initial={{ opacity: 0, scale: 0.95, y: 20 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.95, y: 20 }}
              className="bg-white w-full max-w-5xl rounded-[32px] overflow-hidden shadow-2xl flex flex-col lg:flex-row relative max-h-[90vh] overflow-y-auto hide-scrollbar"
            >
              {/* <button onClick={() => setIsModalOpen(false)} className="absolute top-4 right-4 z-50 p-2 bg-gray-100 hover:bg-gray-200 rounded-full transition text-gray-600">
                <X size={20} />
              </button> */}
<button onClick={handleCloseModal} className="absolute top-4 right-4 z-50 p-2 bg-gray-100 hover:bg-gray-200 rounded-full transition text-gray-600">
  <X size={20} />
</button>
              {/* Form Side */}
              <div className="w-full lg:w-3/5 p-6 sm:p-8 md:p-12">
                <h2 className="text-3xl font-black mb-6 text-[#4A2511]">Book Your Spot</h2>

                {bookedSlot ? (
                  <div className="py-10 text-center">
                    <CheckCircle className="text-green-500 mx-auto mb-4 w-16 h-16" />
                    <h3 className="text-2xl font-black text-[#4A2511]">Registration Confirmed!</h3>
                    <p className="font-bold text-orange-900/70 mt-4">
                      You are scheduled for the <strong>{workshopConfig[bookedSlot.type].title}</strong> on <br />
                      <span className="text-orange-600">{formatDateForUI(bookedSlot.date)}</span> ({bookedSlot.slotName}).
                    </p>
                    {/* <button onClick={() => setIsModalOpen(false)} className="mt-8 px-8 py-3 bg-[#4A2511] text-white rounded-xl font-bold">Done</button> */}
               
               <button onClick={handleCloseModal} className="mt-8 px-8 py-3 bg-[#4A2511] text-white rounded-xl font-bold">Done</button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-8">
                    
                    {/* Step 1: Select Workshop */}
                    <div className="space-y-3">
                      <p className="text-xs font-black uppercase tracking-widest text-orange-600 flex items-center gap-2"><span className="bg-orange-100 px-2 py-0.5 rounded">1</span> Select Workshop</p>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {Object.entries(workshopConfig).map(([key, config]) => (
                          <button 
                            key={key} type="button" onClick={() => handleTypeSelect(key)}
                            className={`p-4 rounded-2xl border-2 text-left transition-all ${userData.type === key ? "bg-orange-50 border-orange-500 shadow-md" : "border-gray-200 bg-white hover:border-orange-300"}`}
                          >
                            <h4 className={`font-black ${userData.type === key ? "text-orange-700" : "text-gray-800"}`}>{config.title}</h4>
                            <p className="text-xs text-gray-500 mt-1">{config.desc}</p>
                            <div className="mt-2 text-sm font-bold text-[#4A2511]">₹{config.price.toLocaleString()}</div>
                          </button>
                        ))}
                      </div>
                    </div>

                    <AnimatePresence>
                      {userData.type && (
                        <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} className="space-y-8 overflow-hidden">
                          
                          {/* Step 2: Details */}
                          <div className="space-y-3 mt-4">
                            <p className="text-xs font-black uppercase tracking-widest text-orange-600 flex items-center gap-2"><span className="bg-orange-100 px-2 py-0.5 rounded">2</span> Your Details</p>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                              <div className="relative"><User className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-900/40 w-5 h-5" /><input type="text" name="name" placeholder="Full Name" required value={userData.name} onChange={handleChange} className="w-full pl-11 pr-4 py-3 rounded-xl bg-[#F7F3EB] border-2 border-transparent focus:border-orange-500 font-bold outline-none text-[#4A2511] placeholder-orange-900/40" /></div>
                              <div className="relative"><Phone className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-900/40 w-5 h-5" /><input type="tel" name="mobile" placeholder="WhatsApp Number" required value={userData.mobile} onChange={handleChange} className="w-full pl-11 pr-4 py-3 rounded-xl bg-[#F7F3EB] border-2 border-transparent focus:border-orange-500 font-bold outline-none text-[#4A2511] placeholder-orange-900/40" /></div>
                            </div>
                          </div>

                          {/* Step 3: Dates */}
                          <div className="space-y-3">
                            <p className="text-xs font-black uppercase tracking-widest text-orange-600 flex items-center gap-2"><span className="bg-orange-100 px-2 py-0.5 rounded">3</span> Select Date</p>
                            {dates.length === 0 ? <p className="text-sm font-bold text-gray-500">No dates available currently.</p> : (
                              <div className="flex flex-wrap gap-2">
                                {dates.map(d => (
                                  <button key={d} type="button" onClick={() => fetchSlotsForDate(d)} className={`px-4 py-2 rounded-xl text-sm font-black transition-all ${userData.date === d ? "bg-orange-500 text-white shadow-md" : "bg-orange-50 text-orange-900 border border-orange-200/50 hover:bg-orange-100"}`}>{formatDateForUI(d)}</button>
                                ))}
                              </div>
                            )}
                          </div>

                          {/* Step 4: Slots */}
                          {userData.date && (
                            <div className="space-y-3">
                              <p className="text-xs font-black uppercase tracking-widest text-orange-600 flex items-center gap-2"><span className="bg-orange-100 px-2 py-0.5 rounded">4</span> Pick a Session</p>
                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                {Object.entries(slots).map(([key, s]) => {
                                  const isFull = s.booked >= s.limit;
                                  return (
                                    <button key={key} type="button" disabled={isFull} onClick={() => setUserData({...userData, slot: key})} className={`p-4 rounded-xl border-2 text-left transition-all ${isFull ? "opacity-50 bg-[#F7F3EB] cursor-not-allowed border-transparent" : userData.slot === key ? "bg-[#4A2511] border-[#4A2511] text-white shadow-md" : "border-orange-200 bg-white hover:border-orange-400"}`}>
                                      <div className="font-black text-sm">{s.name}</div>
                                      <div className={`text-[10px] font-bold uppercase mt-1 ${isFull ? "text-red-500" : userData.slot === key ? "text-orange-200" : "text-orange-900/60"}`}>{isFull ? "Full" : `${s.limit - s.booked} spots left`}</div>
                                    </button>
                                  )
                                })}
                              </div>
                            </div>
                          )}

                          <button disabled={isSubmitting || !userData.slot} type="submit" className="w-full mt-4 py-4 bg-orange-500 hover:bg-orange-600 disabled:bg-gray-300 text-white rounded-xl font-black text-lg shadow-xl shadow-orange-500/20 transition-all">
                            {isSubmitting ? "Confirming..." : (authUser ? "Confirm" : "Login to Confirm")}
                          </button>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </form>
                )}
              </div>

              {/* DYNAMIC SIDEBAR PRICING */}
              <div className="w-full lg:w-2/5 bg-[#4A2511] p-8 sm:p-12 text-[#F7F3EB] flex flex-col justify-between">
                <div>
                  <h4 className="text-orange-400 font-black text-sm uppercase tracking-widest mb-8">Summary</h4>
                  <div className="space-y-6">
                    {!userData.type && (
                      <div className="text-orange-900/60 text-sm italic">Select a workshop to view pricing.</div>
                    )}
                    
                    {userData.type === 'experiential' && (
                      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                        <div className="flex justify-between items-start border-b border-orange-900/50 pb-4">
                          <div>
                            <span className="block font-bold opacity-80">{workshopConfig.experiential.title}</span>
                            <span className="text-xs opacity-60">Workshop Fee</span>
                          </div>
                          <span className="text-xl font-black">₹{workshopConfig.experiential.price.toLocaleString()}</span>
                        </div>
                        <div className="flex justify-between items-end pt-4">
                          <span className="font-black text-orange-400 text-lg">Total</span>
                          <span className="text-4xl font-black text-white">₹{workshopConfig.experiential.price.toLocaleString()}</span>
                        </div>
                      </motion.div>
                    )}

                    {userData.type === '5day' && (
                      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                        <div className="flex justify-between items-start border-b border-orange-900/50 pb-4">
                          <div>
                            <span className="block font-bold opacity-80">{workshopConfig["5day"].title}</span>
                            <span className="text-xs opacity-60">Workshop Classes</span>
                          </div>
                          <span className="text-xl font-black">₹7,000</span>
                        </div>
                        <div className="flex justify-between items-center border-b border-orange-900/50 py-4">
                          <div>
                            <span className="block font-bold opacity-80">Add-on Hive Kit</span>
                            <span className="text-xs opacity-60 line-through">₹7,500</span>
                          </div>
                          <span className="text-xl font-black text-orange-400">₹5,000</span>
                        </div>
                        <div className="flex justify-between items-end pt-4">
                          <span className="font-black text-orange-400 text-lg">Total Overall</span>
                          <span className="text-4xl font-black text-white">₹12,000</span>
                        </div>
                      </motion.div>
                    )}
                  </div>
                </div>
                
                <div className="space-y-4 mt-12">
                  <div className="flex items-center gap-4 bg-white/5 p-4 rounded-2xl border border-white/10"><Shield className="text-orange-400 w-5 h-5 shrink-0" /><span className="text-sm font-bold">Safety Gear Provided</span></div>
                  <div className="flex items-center gap-4 bg-white/5 p-4 rounded-2xl border border-white/10"><BookOpen className="text-orange-400 w-5 h-5 shrink-0" /><span className="text-sm font-bold">Expert Instructors</span></div>
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </div>
  );
}
